import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Dropdown from '../../components/elements/dropdown01';
import RadioButton from '../../components/elements/radioButton01';
import Loader from '../../components/loader';
import * as Styled from './styled';
import axios from 'axios';
import '../../lib/functions';
import base64 from 'base-64';
import Buttonloader from '../../components/buttonLoader';
import Editor from '../../components/textEditor';
import RichQuestionEditor from '../../components/textEditor/EditorForImageQuestion';
import BashComponent from '../../components/addBash/bashComponent'
import deleteIcon from '../../images/delete.svg';
import uploadIcon from '../../images/upload.svg';
import JSZip from "jszip";
import { getRequest, addRequest, addClear, ownerRequest } from './actions';
import { filterRequest } from '../assessmentQuestion/actions';

const TYPE_SKILL_TOPIC_DEFAULTS = {
  SQL: { skill: 'SQL', topic: 'SQL' },
  BASH: { skill: 'Bash', topic: 'BASH' },
};

const sqlApiErrorMessage = (error, fallback) =>
  error?.response?.data?.meta?.message
  || error?.response?.data?.message
  || fallback;

class AddAssessmentQuestion extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pageMode: '',
      difficulty: [
        { id: 'EASY', title: 'Easy' },
        { id: 'MEDIUM', title: 'Medium' },
        { id: 'HARD', title: 'Hard' },
      ],
      ownerTypes: [
        { id: 'COFFEEE', title: 'Coffeee' },
        { id: 'BOOTCAMP', title: 'Bootcamp' },
        { id: 'RECRUITER', title: 'Recruiter' },
        { id: 'CAMPAIGN', title: 'Campaign' },
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' },
        { id: 'PRACTICE', title: 'Practice' },
      ],
    }
  }

  UNSAFE_componentWillMount() {
    let pageMode = 'add';
    this.resetInput();

    if (window && window.location && window.location.pathname) {
      const pathArr = window.location.pathname.split('/');
      if (typeof pathArr[3] !== 'undefined' && pathArr[3] !== '') {
        this.props.getRequest(pathArr[3]);
        pageMode = pathArr[2];
      }
    }
    this.props.filterRequest();
    this.setState({ pageMode });
  }

  componentDidMount() {
    this.fetchSqlSchemas();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.addAssessmentQuestion) {
      if (nextProps.addAssessmentQuestion.addQuestion
        && nextProps.addAssessmentQuestion.addQuestion.code === 200) {
        window.location = '/assessment-question';
      }

      if (this.state.pageMode === 'edit'
      && this.state.question
      && typeof this.state.question.question_id === 'undefined'
      && nextProps.addAssessmentQuestion.getQuestion
      && nextProps.addAssessmentQuestion.getQuestion.data
      && nextProps.addAssessmentQuestion.getQuestion.data[0]) {
        const que = nextProps.addAssessmentQuestion.getQuestion.data[0];
        const question = this.state.question;
        let mcqData = [];
        let orderingData = this.emptyOrderingData();
        let compilerData = this.state.compilerData;
        let sqlData = this.state.sqlData;

        question.question_id = que.question_id || '';
        question.question_title = que.question_title || '';
        question.master_skill_id = que.master_skill_id || '';
        question.category_name = que.category_name || '';
        question.topic_id = que.topic_id || '';
        question.topic_name = que.topic_name || '';
        question.question_type_id = que.question_type_id || '';
        question.question_type_code = que.question_type_code || '';
        question.difficulty_level = que.difficulty_level || '';
        question.question_details = que.question_detail || que.description || '';
        question.is_bootcamp = que.is_bootcamp || false;
        question.answer = que?.answer || '';
        question.question_image = que.question_image || false;
        let solutionCode = (Array.isArray(que.solution_code) && que.solution_code.length) ? que.solution_code[0] : "";

        if (solutionCode == "") {
          solutionCode = {
            fileReaderFn: "",
            customInputFn: "",
            matchOutputFn: "",
            solutionFn: "",
            id: '',
            predefinedCode: "",
          };
        } else {
          solutionCode["id"] = solutionCode.id;
          solutionCode["fileReaderFn"] = solutionCode.fileReaderFn || "";
          solutionCode["customInputFn"] = solutionCode.customInputFn || "";
          solutionCode["matchOutputFn"] = solutionCode.matchOutputFn || "";
          solutionCode["solutionFn"] = solutionCode.solutionFn || "";
          solutionCode["predefinedCode"] = solutionCode.predefinedCode || ""
          question.boilerPlate = solutionCode.id;
        }

        solutionCode["loader"] = false;
        solutionCode["outputResult"] = [];
        solutionCode["compileMode"] = "fileread";
        solutionCode["custom_input"] = "";
        solutionCode["error"] = "";


        if (Array.isArray(que.boiler_plate)) {
          let boilerPlateArrToSet = [];
          for (let i = 0; i < que.boiler_plate.length; i++) {
            let temp = JSON.parse(que.boiler_plate[i]);
            boilerPlateArrToSet.push({
              id: temp.id,
              languageCode: temp.languageCode,
              name: temp.name,
              fileReaderFn: temp.fileReaderFn,
              customInputFn: temp.customInputFn,
              matchOutputFn: temp.matchOutputFn,
              solutionFn: temp.solutionFn,
              predefinedCode: temp.predefinedCode || "",
              compileLoader: false,
              outputResult: [],
              compileMode: 'fileread',
              custom_input: "",
              error: "",
            })
          }

          let parentBoilerPlateArr = this.state.boilerPlate;
          boilerPlateArrToSet.sort((t, o) => t.id - o.id);
          parentBoilerPlateArr.sort((t, o) => t.id - o.id);
          let missingLanguages = [];

          for (let i = 0; i < parentBoilerPlateArr.length; i++) {
            let si = 0;
            let ei = boilerPlateArrToSet.length - 1;
            let idToSearch = parentBoilerPlateArr[i].id;
            let ansIdx = -1;

            while (si <= ei) {
              let mid = (si + ei) >> 1;
              let midObj = boilerPlateArrToSet[mid];
              if (midObj.id == idToSearch) {
                ansIdx = mid;
                break;
              } else if (idToSearch > midObj.id) {
                si = mid + 1;
              } else {
                ei = mid - 1;
              }
            }

            if (ansIdx === -1) {
              missingLanguages.push({
                id: parentBoilerPlateArr[i].id,
                languageCode: parentBoilerPlateArr[i].languageCode,
                name: parentBoilerPlateArr[i].name,
                fileReaderFn: "",
                customInputFn: "",
                matchOutputFn: "",
                solutionFn: "",
                compileLoader: false,
                outputResult: [],
                compileMode: 'fileread',
                custom_input: "",
                error: "",
                predefinedCode: "",
              });
            }
          }

          boilerPlateArrToSet = [...boilerPlateArrToSet, ...missingLanguages];

          boilerPlateArrToSet.sort((t, o) => t.id - o.id);

          for (let i = 0; i < boilerPlateArrToSet.length; i++) {
            if (boilerPlateArrToSet[i].id == parentBoilerPlateArr[i].id && (boilerPlateArrToSet[i].name == "" || boilerPlateArrToSet[i].name == undefined)) {
              boilerPlateArrToSet[i].name = parentBoilerPlateArr[i].name;
            }
          }

          this.setState({ boilerPlate: boilerPlateArrToSet })
        }


        if (que.owners) {
          const ownerName = que.owners.split('_');
          if (ownerName[0] === 'BOOTCAMP' || ownerName[0] === 'RECRUITER'||ownerName[0] === 'PRACTICE') {
            question.owners = ownerName[0];
            nextProps.ownerRequest(ownerName[0]);
            if(que.question_type_code === 'MOCKINTERVIEW' && ownerName[0] === 'RECRUITER')
              question.owners_id = que?.company_id || null;
            else 
              question.owners_id = ownerName[1] ? ownerName[1] : '';
          } else {
            question.owners = 'COFFEEE';
            question.owners_id = '';
          }
        }

        if (que.question_type_code === 'MCQ'
        && que.question_data
        && que.question_data.options
        && que.question_data.options.length > 0) {
          const options = que.question_data.options || [];
          const correct_answer = que.question_data.correct_answer || [];

          for (let i = 0; i < options.length; i++) {
            let is_correct = false;
            if (correct_answer.includes(i)) is_correct = true;
            mcqData.push({ index: options[i].index, option: options[i].option, is_correct });
          }
        } else if (que.question_type_code === 'ORDERING'
        && que.question_data
        && Array.isArray(que.question_data.options)) {
          orderingData = this.orderingDataFromSaved(que.question_data);
        } else if (que.question_type_code === 'COMPILER') {
          compilerData = que.question_data;
           if (compilerData && compilerData.length > 0) {
            for (let i = 0; i < compilerData.length; i++) {
              delete compilerData[i].input_link;
              delete compilerData[i].output_link;
              let cd = compilerData[i];
              let keys_to_add = ['execution_time' ,'zip_folder_link', 'base64_folder', 'type'];
              for (let j = 0; j < keys_to_add.length; j++) {
                if (!cd.hasOwnProperty(keys_to_add[j])) {
                  cd[keys_to_add[j]] = ''
                }
              }
            }
          }
        } else if (que.question_type_code === 'SQL') {
          const cases = Array.isArray(que.test_cases) ? que.test_cases : [];
          const hints = Array.isArray(que.hints) ? que.hints : [];

          sqlData = {
            marks: typeof que.marks === 'number' ? que.marks : 10,
            active: que.active !== false,
            starter_query: que.starter_query || '',
            solution_query: que.solution_query || '',
            hints: hints.length > 0 ? hints : [''],
            available_tables: [],
            selected_table_names: Array.isArray(que.schema_preview)
              ? que.schema_preview.map((t) => t.name).filter(Boolean)
              : [],
            schema_selection_touched: Array.isArray(que.schema_preview) && que.schema_preview.length > 0,
            schema_preview: Array.isArray(que.schema_preview) ? que.schema_preview : [],
            test_cases: cases.map((tc) => ({
              ...this.emptySqlTestCase(),
              schema_id: tc.schema_id || '',
              test_case_code: tc.test_case_code || '',
              is_hidden: tc.is_hidden === true,
              title: tc.title || '',
              description: tc.description || '',
              expected_result: tc.expected_result
                ? JSON.stringify(tc.expected_result, null, 2)
                : '',
            })),
          };

          if (sqlData.test_cases.length === 0) {
            sqlData.test_cases = [this.emptySqlTestCase()];
          }
          sqlData.test_cases = this.syncSqlTestCaseCodes(sqlData.test_cases);
        }

        const bashInitialData = que.question_type_code === 'BASH' ? que.bash : null;
        this.applyTypeDefaults(question, this.state.error);

        this.setState({ question, mcqData, orderingData, compilerData, solutionCode, sqlData, bashInitialData }, () => {
          if (que.question_type_code === 'SQL') {
            this.loadSqlSchemaPreview();
          }
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.addClear();
    this.resetInput();
  }

  emptySqlTestCase = () => ({
    schema_id: '',
    test_case_code: 'SAMPLE',
    is_hidden: false,
    title: '',
    description: '',
    // Pasted JSON overrides the solution-query run; kept as text so an invalid
    // paste can be reported instead of silently dropped.
    expected_result: '',
    runRows: null,
    runError: '',
    runLoader: false,
  })

  emptySqlData = () => ({
    marks: 10,
    active: true,
    starter_query: '',
    solution_query: '',
    hints: [''],
    available_tables: [],
    selected_table_names: [],
    schema_selection_touched: false,
    schema_preview: [],
    test_cases: [this.emptySqlTestCase()],
  })

  resetInput = () => {
    this.setState({
      newItem: {
        category: false,
        topic: false,
      },
      question: {
        question_title: '',
        category_name: '',
        question_image:'',
        master_skill_id: '',
        newCategory: '',
        topic_name: '',
        topic_id: '',
        newTopic: '',
        difficulty_level: '',
        question_type_id: '',
        question_type_code: '',
        question_details: '',
        answer:'',
        is_bootcamp: false,
        owners: '',
        owners_id: '',
      },
      error: {
        question_title: '',
        master_skill_id: '',
        newCategory: '',
        topic_id: '',
        newTopic: '',
        difficulty_level: '',
        question_type_id: '',
        question_details: '',
        options: '',
        testCase: '',
        owners_id: '',
        codeCompilation: '',
        sqlTestCase: '',
        bashTestCase:'',
      },
      bashData:null,
      bashInitialData: null,
      orderingData: {
        stepCount: 4,
        steps: ['', '', '', ''],
        candidateOrder: [],
      },
      sqlData: this.emptySqlData(),
      sqlSchemas: [],
      sqlSchemaForm: { open: false, schema_name: '', setup_sql: '', loader: false, error: '', success: '' },
      sqlSchemaAppendForm: { open: false, schema_id: '', setup_sql: '', loader: false, error: '', success: '' },
      sqlSchemaRowsForm: { open: false, schema_id: '', insert_sql: '', loader: false, error: '', success: '' },
      compilerData: [
        {std_input: '', std_output: '', visibility: 'PUBLIC', execution_time: '', type: 'CONSOLE', zip_folder_link: '', base64_folder: ''},
        {std_input: '', std_output: '', visibility: 'PUBLIC', execution_time: '', type: 'CONSOLE', zip_folder_link: '', base64_folder: ''},
      ],
      boilerPlate: [
        {
          id: 49,
          languageCode: "C",
          name: "C (GCC 8.3.0)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 53,
          languageCode: "C++",
          name: "C++ (GCC 8.3.0)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 62,
          languageCode: "Java",
          name: "Java (OpenJDK 13.0.1)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 63,
          languageCode: "Javascript",
          name: "JavaScript (Node.js 12.14.0)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 71,
          languageCode: "Python",
          name: "Python (3.8.1)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 60,
          languageCode: "Go",
          name: "Go (1.13.5)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: "",
        },
        {
          id: 68,
          languageCode: "PHP",
          name: "PHP (7.4.1)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: ""
        },
        {
          id: 51,
          languageCode: "C#",
          name: "C# (Mono 6.6.0.161)",
          fileReaderFn: "",
          customInputFn: "",
          matchOutputFn: "",
          solutionFn: "",
          compileLoader: false,
          outputResult: [],
          compileMode: 'fileread',
          custom_input: "",
          error: "",
          predefinedCode: ""
        }
      ],
      mcqData: [
        {option: '', is_correct: false},
        {option: '', is_correct: false},
        {option: '', is_correct: false},
        {option: '', is_correct: false},
      ],
      solutionCode: {
        fileReaderFn: "",
        customInputFn: "",
        matchOutputFn: "",
        solutionFn: "",
        id: '',
        loader: false,
        outputResult: [],
        compileMode: 'fileread',
        custom_input: "",
        error: "",
        predefinedCode: "",
      },
      testCaseLoader: false,
    });
  }

  removeError = (key) => {
    const error = this.state.error;
    error[key] = '';
    this.setState({ error });
  }

  addNewQuestion = (val) => {
    const newItem = this.state.newItem;
    newItem[val] = !newItem[val];
    this.setState({ newItem })

    if (val === 'category') {
      this.removeError('master_skill_id');
      this.removeError('newCategory');
    } else if (val === 'topic') {
      this.removeError('topic_id');
      this.removeError('newTopic');
    }
  }

  orderingStepText = (value) => String(value || '').trim()

  orderingStepPlain = (value) => {
    const text = String(value || '');
    if (!/^\s*<p\b/i.test(text)) return text;
    return text
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  emptyOrderingData = () => ({
    stepCount: 4,
    steps: ['', '', '', ''],
    candidateOrder: [],
  })

  orderingDataFromSaved = (questionData) => {
    const options = Array.isArray(questionData?.options) ? questionData.options : [];
    const correct = Array.isArray(questionData?.correct_answer)
      ? questionData.correct_answer.map(String)
      : [];
    const textById = new Map(
      options.map((opt, index) => [
        String(opt?.id ?? index),
        this.orderingStepPlain(opt?.option || opt?.text || ''),
      ])
    );
    const steps = correct.length
      ? correct.map((id) => textById.get(id) || '')
      : options.map((opt) => opt?.option || opt?.text || '');
    const count = Math.min(6, Math.max(4, steps.length || 4));
    while (steps.length < count) steps.push('');
    const correctAnswer = correct.length
      ? correct
      : options.map((opt, index) => String(opt?.id ?? String.fromCharCode(97 + index)));
    return {
      stepCount: count,
      steps: steps.slice(0, count),
      correctAnswer,
      candidateOrder: options.map((opt, index) => ({
        id: String(opt?.id ?? String.fromCharCode(97 + index)),
        option: this.orderingStepPlain(opt?.option || opt?.text || ''),
      })),
    };
  }

  setOrderingStepCount = (value) => {
    const count = parseInt(value, 10);
    const error = { ...this.state.error, options: '' };
    if (!Number.isInteger(count) || count < 4 || count > 6) {
      this.setState({
        error: { ...error, options: 'Enter a step count from 4 to 6' },
      });
      return;
    }
    const steps = [...(this.state.orderingData?.steps || [])];
    while (steps.length < count) steps.push('');
    this.setState({
      orderingData: {
        stepCount: count,
        steps: steps.slice(0, count),
        candidateOrder: [],
      },
      error,
    });
  }

  changeOrderingStep = (index, value) => {
    const current = this.state.orderingData?.steps || [];
    if (current[index] === value) return;
    const steps = [...current];
    const textChanged = this.orderingStepText(current[index]) !== this.orderingStepText(value);
    steps[index] = value;
    this.setState({
      orderingData: {
        ...this.state.orderingData,
        steps,
        candidateOrder: textChanged ? [] : (this.state.orderingData?.candidateOrder || []),
      },
    });
    this.removeError('options');
  }

  shuffleOrderingSteps = () => {
    const steps = this.state.orderingData?.steps || [];
    const stepText = steps.map((step) => this.orderingStepText(step));
    const selectedCount = this.state.orderingData?.stepCount || steps.length;
    if (steps.length < 4 || steps.length > 6 || stepText.some((step) => step === '')) {
      const error = { ...this.state.error, options: `Enter ${selectedCount} options` };
      this.setState({ error });
      return;
    }
    const items = steps.map((option, index) => ({
      id: String.fromCharCode(97 + index),
      option,
    }));
    const correctAnswer = items.map((item) => item.id);
    const options = [...items];
    for (let i = options.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [options[i], options[j]] = [options[j], options[i]];
    }
    if (options.every((opt, index) => opt.id === correctAnswer[index])) {
      [options[0], options[1]] = [options[1], options[0]];
    }
    this.setState({
      orderingData: {
        ...this.state.orderingData,
        correctAnswer,
        candidateOrder: options,
      },
    });
    this.removeError('options');
  }

  addNewOption = () => {
    const mcqData = this.state.mcqData || [];
    mcqData.push({option: '', is_correct: false});
    this.setState({ mcqData });
  }

  deleteOption = (index) => {
    const mcqData = this.state.mcqData || [];
    if (mcqData) mcqData.splice(index, 1);
    this.setState({ mcqData });
    this.removeError('options');
  }

  selectOption = (index) => { 
    const mcqDataCopy = [...this.state.mcqData];
    if (mcqDataCopy[index] && typeof mcqDataCopy[index].is_correct !== 'undefined') {
      mcqDataCopy[index].is_correct = !mcqDataCopy[index].is_correct;
    }
    this.setState({ mcqData: mcqDataCopy });
    this.removeError('options');
  }

  // changeOption = (id, value) => {
  //   // const value = e.target.value;
  //   console.log(value,id,'QQQQQQQQQQQQQQ')
  //   const mcqData = this.state.mcqData || [];
  //   // if (mcqData[id]) {
  //     mcqData[id].option = value;
  //   // }
  //   this.setState({ mcqData });
  //   this.removeError('options');
  // }
  changeOption = (id,value) => {
    const { mcqData } = this.state;
    const newMcqData = [...mcqData];
    newMcqData[id].option = value;
    this.setState({ mcqData: newMcqData });
  }

  cancelQuestion = () => {
    this.resetInput()
  }

  inputChange = (e) => {
    const { id, value } = e.target;
    const question = this.state.question;
    const error = this.state.error;
    question[id] = value;
    if (error[id]) error[id] = '';
    this.setState({ question, error });
  }
  editorInputChange = (id,value) => {
    // let {id,value}=e.target
    const question = this.state.question;
    const error = this.state.error;
    question[id] = value;
    if (error[id]) error[id] = '';
    this.setState({ question, error });
  }

  // SQL and Bash questions always use the same skill and topic; matched by name
  // so the ids can differ between environments.
  applyTypeDefaults = (question, error) => {
    const defaults = TYPE_SKILL_TOPIC_DEFAULTS[question.question_type_code];
    const filter = this.props.assessmentQuestion && this.props.assessmentQuestion.filter;
    if (!defaults || !filter) return;

    const findByName = (list, field, wanted) => {
      const target = wanted.trim().toLowerCase();
      return (list || []).find((item) => item && typeof item[field] === 'string' && item[field].trim().toLowerCase() === target);
    };

    const skill = findByName(filter.category, 'category_name', defaults.skill);
    if (skill) {
      question.master_skill_id = skill.id;
      question.category_name = skill.category_name;
      error.master_skill_id = '';
    }

    const topic = findByName(filter.topic, 'topic_name', defaults.topic);
    if (topic) {
      question.topic_id = topic.id;
      question.topic_name = topic.topic_name;
      error.topic_id = '';
    }
  }

  dropdownChange = (id, name) => {
    const question = this.state.question;
    const error = this.state.error;

    if (typeof id !== 'undefined' && id !== null && id !== '') {
      question[name] = id;
      error[name] = '';
    }

    const filterLoop = (name, id, title) => {
      if (this.props.assessmentQuestion && this.props.assessmentQuestion.filter) {
        const filter = this.props.assessmentQuestion.filter;
        if (filter && filter[name] && filter[name].length > 0) {
          for (let x = 0; x < filter[name].length; x+= 1) {
            if (filter[name][x].id === id) return filter[name][x][title];
          }
        }
      }
    }

    if (name === 'master_skill_id') question.category_name = filterLoop('category', id, 'category_name')
    else if (name === 'topic_id') question.topic_name = filterLoop('topic', id, 'topic_name')
    else if (name === 'question_type_id') {
      question.question_type_code = filterLoop('question_type', id, 'question_type_code')
      this.applyTypeDefaults(question, error);
    }
    else if (name === 'boilerPlate') {
        let solutionCode = this.state.solutionCode;
        solutionCode.id = id;
        this.setState({ solutionCode });
    }
    this.setState({ question, error });
  }

  selectCase = (index, visibility) => {
    const compilerData = this.state.compilerData;
    compilerData[index].visibility = visibility;
    this.setState({ compilerData });
    this.removeError('testCase');
  }

  changeTestCase = (e, index, mode) => {
    const value = e.target.value || '';
    const compilerData = this.state.compilerData;
    if (compilerData[index]) {
      compilerData[index][mode] = value;
      this.setState({ compilerData });
      this.removeError('testCase');
    }
  }

  addNewTestCase = () => {
    const compilerData = this.state.compilerData || [];
    compilerData.push({std_input: '', std_output: '', visibility: 'PUBLIC', execution_time: '', type: 'CONSOLE', zip_folder_link: '', base64_folder: ''});
    this.setState({ compilerData });
  }

  handleInputTime = (e, optIndex, type) => {
    let compilerData = this.state.compilerData;
    let val = e.target.value;
    let time = (typeof(val) == 'string' && val !== "" ? val = parseInt(val) : 0)
    compilerData[optIndex].execution_time = time;
    this.setState({ compilerData });
  }

  deleteTestCase = (index) => {
    const compilerData = this.state.compilerData || [];
    if (compilerData) {
      compilerData.splice(index, 1);
      this.removeError('testCase');
    }
    this.setState({ compilerData });
  }

  /* --------------------------------- SQL ---------------------------------- */

  sqlRequestOptions = () => ({
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    }
  })

  fetchSqlSchemas = async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_PATH}assessments/sql/filter-list`,
        this.sqlRequestOptions()
      );
      this.setState({ sqlSchemas: result?.data?.data?.schemas || [] });
    } catch (e) {
      console.log('failed to load sql schemas', e);
    }
  }

  sqlFieldChange = (field, value) => {
    const sqlData = this.state.sqlData;
    sqlData[field] = value; 
    this.setState({ sqlData });
    this.removeError('sqlTestCase');
  }

  sqlHintChange = (index, value) => {
    const sqlData = this.state.sqlData;
    sqlData.hints[index] = value;
    this.setState({ sqlData });
  }

  addSqlHint = () => {
    const sqlData = this.state.sqlData;
    sqlData.hints.push('');
    this.setState({ sqlData });
  }

  deleteSqlHint = (index) => {
    const sqlData = this.state.sqlData;
    sqlData.hints.splice(index, 1);
    if (sqlData.hints.length === 0) sqlData.hints.push('');
    this.setState({ sqlData });
  }

  /**
   * Visibility drives the code label only: SAMPLE or HIDDEN (never SAMPLE_2, etc.).
   * Multiple cases of the same type are distinguished by row id + schema.
   */
  syncSqlTestCaseCodes = (test_cases) =>
    test_cases.map((tc) => ({
      ...tc,
      test_case_code: tc.is_hidden === true ? 'HIDDEN' : 'SAMPLE',
    }));

  sqlTestCaseChange = (index, field, value, callback) => {
    const sqlData = this.state.sqlData;
    if (!sqlData.test_cases[index]) return;
    const testCase = sqlData.test_cases[index];

    if (field === 'is_hidden') {
      testCase.is_hidden = value === true;
    } else {
      testCase[field] = value;
    }

    sqlData.test_cases = this.syncSqlTestCaseCodes(sqlData.test_cases);
    this.setState({ sqlData }, typeof callback === 'function' ? callback : undefined);
    this.removeError('sqlTestCase');
  }

  addSqlTestCase = () => {
    const sqlData = this.state.sqlData;
    sqlData.test_cases = this.syncSqlTestCaseCodes(
      sqlData.test_cases.concat([this.emptySqlTestCase()])
    );
    this.setState({ sqlData });
  }

  deleteSqlTestCase = (index) => {
    const sqlData = this.state.sqlData;
    sqlData.test_cases.splice(index, 1);
    if (sqlData.test_cases.length === 0) sqlData.test_cases.push(this.emptySqlTestCase());
    sqlData.test_cases = this.syncSqlTestCaseCodes(sqlData.test_cases);
    this.setState({ sqlData });
    this.removeError('sqlTestCase');
  }

  /**
   * Runs the reference solution against one case's schema so the author can see
   * the rows that will be saved as that case's expected result.
   */
  runSqlTestCase = async (index) => {
    const sqlData = this.state.sqlData;
    const testCase = sqlData.test_cases[index];
    if (!testCase) return;

    if (!testCase.schema_id) {
      testCase.runError = 'Select a schema first';
      this.setState({ sqlData });
      return;
    }
    if (sqlData.solution_query.trim() === '') {
      testCase.runError = 'Enter a solution query first';
      this.setState({ sqlData });
      return;
    }

    testCase.runLoader = true;
    testCase.runError = '';
    this.setState({ sqlData });

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_PATH}assessments/sql/run-query`,
        { schema_id: testCase.schema_id, query: sqlData.solution_query },
        this.sqlRequestOptions()
      );
      testCase.runRows = result?.data?.data?.rows || [];
      testCase.runError = '';
    } catch (e) {
      testCase.runRows = null;
      testCase.runError = sqlApiErrorMessage(e, 'Query failed');
    }

    testCase.runLoader = false;
    this.setState({ sqlData });
  }

  buildSelectedSchemaPreview = (availableTables, selectedNames) => {
    const nameSet = {};
    for (let i = 0; i < (selectedNames || []).length; i++) {
      nameSet[selectedNames[i]] = true;
    }
    return (availableTables || []).filter((t) => t && t.name && nameSet[t.name]);
  }

  getSchemaTablePool = (sqlData, extraTable) => {
    const available = sqlData.available_tables || [];
    if (available.length) return available;

    const pool = [];
    const seen = {};
    const push = (table) => {
      if (!table || !table.name || seen[table.name]) return;
      seen[table.name] = true;
      pool.push(table);
    };
    (sqlData.schema_preview || []).forEach(push);
    push(extraTable);
    return pool;
  }

  loadSqlSchemaPreview = async () => {
    const schemaIds = [];
    const testCases = this.state.sqlData.test_cases || [];
    for (let i = 0; i < testCases.length; i++) {
      const id = testCases[i].schema_id;
      if (id && schemaIds.indexOf(id) === -1) schemaIds.push(id);
    }

    if (!schemaIds.length) {
      const sqlData = { ...this.state.sqlData };
      sqlData.available_tables = [];
      if (!sqlData.schema_selection_touched) {
        sqlData.selected_table_names = [];
        sqlData.schema_preview = [];
      }
      this.setState({ sqlData });
      return;
    }

    const preview = [];
    const seenTables = {};

    for (let i = 0; i < schemaIds.length; i++) {
      try {
        const result = await axios.post(
          `${process.env.REACT_APP_API_PATH}assessments/sql/schema-preview`,
          { schema_id: schemaIds[i] },
          this.sqlRequestOptions()
        );
        const schemaName = result?.data?.data?.schema_name || '';
        const tables = result?.data?.data?.schema_preview || [];
        for (let t = 0; t < tables.length; t++) {
          const table = tables[t];
          const name = table?.name;
          if (!name) continue;
          if (seenTables[name]) {
            preview.push({ ...table, name: `${schemaName}.${name}` });
          } else {
            seenTables[name] = true;
            preview.push(table);
          }
        }
      } catch (e) {
        console.log('failed to load schema preview', e);
      }
    }

    const sqlData = { ...this.state.sqlData };
    const availableNames = preview.map((t) => t.name);
    let selectedNames = Array.isArray(sqlData.selected_table_names)
      ? sqlData.selected_table_names.slice()
      : [];

    if (!sqlData.schema_selection_touched) {
      // First load for a new question: select every table until admin changes it.
      selectedNames = availableNames.slice();
    } else {
      // Keep only names that still exist after schema reload (do NOT re-add unchecked tables).
      selectedNames = selectedNames.filter((name) => availableNames.indexOf(name) !== -1);
    }

    sqlData.available_tables = preview;
    sqlData.selected_table_names = selectedNames;
    sqlData.schema_preview = this.buildSelectedSchemaPreview(preview, selectedNames);
    this.setState({ sqlData });
  }

  isSqlPreviewTableSelected = (tableName) => {
    const selected = this.state.sqlData.selected_table_names || [];
    return selected.indexOf(tableName) !== -1;
  }

  toggleSqlPreviewTable = (table) => {
    const name = table?.name;
    if (!name) return;

    const sqlData = { ...this.state.sqlData };
    const selected = Array.isArray(sqlData.selected_table_names)
      ? sqlData.selected_table_names.slice()
      : [];
    const index = selected.indexOf(name);
    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected.push(name);
    }

    const pool = this.getSchemaTablePool(sqlData, table);
    sqlData.schema_selection_touched = true;
    sqlData.selected_table_names = selected;
    sqlData.schema_preview = this.buildSelectedSchemaPreview(pool, selected);
    this.setState({ sqlData });
    this.removeError('sqlTestCase');
  }

  selectAllSqlPreviewTables = () => {
    const sqlData = { ...this.state.sqlData };
    const pool = this.getSchemaTablePool(sqlData);
    const selected = pool.map((t) => t.name).filter(Boolean);
    sqlData.schema_selection_touched = true;
    sqlData.selected_table_names = selected;
    sqlData.schema_preview = this.buildSelectedSchemaPreview(pool, selected);
    this.setState({ sqlData });
    this.removeError('sqlTestCase');
  }

  clearSqlPreviewTables = () => {
    const sqlData = { ...this.state.sqlData };
    sqlData.schema_selection_touched = true;
    sqlData.selected_table_names = [];
    sqlData.schema_preview = [];
    this.setState({ sqlData });
  }

  sqlSchemaFormChange = (field, value) => {
    const sqlSchemaForm = this.state.sqlSchemaForm;
    sqlSchemaForm[field] = value;
    sqlSchemaForm.error = '';
    sqlSchemaForm.success = '';
    this.setState({ sqlSchemaForm });
  }

  sqlSchemaAppendFormChange = (field, value) => {
    const sqlSchemaAppendForm = this.state.sqlSchemaAppendForm;
    sqlSchemaAppendForm[field] = value;
    sqlSchemaAppendForm.error = '';
    sqlSchemaAppendForm.success = '';
    this.setState({ sqlSchemaAppendForm });
  }

  sqlSchemaRowsFormChange = (field, value) => {
    const sqlSchemaRowsForm = this.state.sqlSchemaRowsForm;
    sqlSchemaRowsForm[field] = value;
    sqlSchemaRowsForm.error = '';
    sqlSchemaRowsForm.success = '';
    this.setState({ sqlSchemaRowsForm });
  }

  toggleSqlSchemaPanel = (panel) => {
    const { sqlSchemaForm, sqlSchemaAppendForm, sqlSchemaRowsForm } = this.state;
    const nextOpen =
      panel === 'create' ? !sqlSchemaForm.open
        : panel === 'append' ? !sqlSchemaAppendForm.open
          : !sqlSchemaRowsForm.open;

    this.setState({
      sqlSchemaForm: { ...sqlSchemaForm, open: panel === 'create' && nextOpen, error: '', success: '' },
      sqlSchemaAppendForm: { ...sqlSchemaAppendForm, open: panel === 'append' && nextOpen, error: '', success: '' },
      sqlSchemaRowsForm: { ...sqlSchemaRowsForm, open: panel === 'rows' && nextOpen, error: '', success: '' },
    });
  }

  createSqlSchema = async () => {
    const sqlSchemaForm = this.state.sqlSchemaForm;

    if (sqlSchemaForm.schema_name.trim() === '') {
      sqlSchemaForm.error = 'Enter a schema name';
      this.setState({ sqlSchemaForm });
      return;
    }
    if (sqlSchemaForm.setup_sql.trim() === '') {
      sqlSchemaForm.error = 'Enter the table definitions (DDL)';
      this.setState({ sqlSchemaForm });
      return;
    }

    sqlSchemaForm.loader = true;
    sqlSchemaForm.error = '';
    sqlSchemaForm.success = '';
    this.setState({ sqlSchemaForm });

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_PATH}assessments/sql/create-schema`,
        { schema_name: sqlSchemaForm.schema_name.trim(), setup_sql: sqlSchemaForm.setup_sql },
        this.sqlRequestOptions()
      );

      const created = result?.data?.data || {};
      const sqlSchemas = this.state.sqlSchemas.concat([{ id: created.id, schema_name: created.schema_name }]);

      sqlSchemaForm.loader = false;
      sqlSchemaForm.success = `Schema "${created.schema_name}" created`;
      sqlSchemaForm.schema_name = '';
      sqlSchemaForm.setup_sql = '';
      this.setState({ sqlSchemas, sqlSchemaForm }, () => this.loadSqlSchemaPreview());
    } catch (e) {
      sqlSchemaForm.loader = false;
      sqlSchemaForm.error = sqlApiErrorMessage(e, 'Failed to create schema');
      this.setState({ sqlSchemaForm });
    }
  }

  appendSqlSchemaTables = async () => {
    const sqlSchemaAppendForm = this.state.sqlSchemaAppendForm;

    if (!sqlSchemaAppendForm.schema_id) {
      sqlSchemaAppendForm.error = 'Select an existing schema';
      this.setState({ sqlSchemaAppendForm });
      return;
    }
    if (sqlSchemaAppendForm.setup_sql.trim() === '') {
      sqlSchemaAppendForm.error = 'Enter the new table SQL (CREATE TABLE and optional INSERTs)';
      this.setState({ sqlSchemaAppendForm });
      return;
    }

    sqlSchemaAppendForm.loader = true;
    sqlSchemaAppendForm.error = '';
    sqlSchemaAppendForm.success = '';
    this.setState({ sqlSchemaAppendForm });

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_PATH}assessments/sql/append-schema`,
        {
          schema_id: sqlSchemaAppendForm.schema_id,
          setup_sql: sqlSchemaAppendForm.setup_sql,
        },
        this.sqlRequestOptions()
      );

      const updated = result?.data?.data || {};
      const schemaName =
        this.state.sqlSchemas.find((s) => s.id === sqlSchemaAppendForm.schema_id)
          ?.schema_name || updated.schema_name || 'schema';

      sqlSchemaAppendForm.loader = false;
      sqlSchemaAppendForm.success = `Added table(s) to "${schemaName}"`;
      sqlSchemaAppendForm.setup_sql = '';
      this.setState({ sqlSchemaAppendForm }, () => this.loadSqlSchemaPreview());
    } catch (e) {
      sqlSchemaAppendForm.loader = false;
      sqlSchemaAppendForm.error = sqlApiErrorMessage(e, 'Failed to update schema');
      this.setState({ sqlSchemaAppendForm });
    }
  }

  appendSqlSchemaRows = async () => {
    const sqlSchemaRowsForm = this.state.sqlSchemaRowsForm;

    if (!sqlSchemaRowsForm.schema_id) {
      sqlSchemaRowsForm.error = 'Select an existing schema';
      this.setState({ sqlSchemaRowsForm });
      return;
    }
    if (sqlSchemaRowsForm.insert_sql.trim() === '') {
      sqlSchemaRowsForm.error = 'Enter INSERT statements for the new rows';
      this.setState({ sqlSchemaRowsForm });
      return;
    }

    sqlSchemaRowsForm.loader = true;
    sqlSchemaRowsForm.error = '';
    sqlSchemaRowsForm.success = '';
    this.setState({ sqlSchemaRowsForm });

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_PATH}assessments/sql/append-schema`,
        {
          schema_id: sqlSchemaRowsForm.schema_id,
          insert_sql: sqlSchemaRowsForm.insert_sql,
        },
        this.sqlRequestOptions()
      );

      const updated = result?.data?.data || {};
      const schemaName =
        this.state.sqlSchemas.find((s) => s.id === sqlSchemaRowsForm.schema_id)
          ?.schema_name || updated.schema_name || 'schema';

      sqlSchemaRowsForm.loader = false;
      sqlSchemaRowsForm.success = `Rows added to "${schemaName}"`;
      sqlSchemaRowsForm.insert_sql = '';
      this.setState({ sqlSchemaRowsForm }, () => this.loadSqlSchemaPreview());
    } catch (e) {
      sqlSchemaRowsForm.loader = false;
      sqlSchemaRowsForm.error = sqlApiErrorMessage(e, 'Failed to insert rows');
      this.setState({ sqlSchemaRowsForm });
    }
  }

  saveQuestion = () => {
    const { 
      question_id, question_title, 
      master_skill_id, newCategory, 
      topic_id, newTopic, 
      difficulty_level, question_type_id, 
      question_type_code, 
      owners, owners_id 
    } = this.state.question;
    const newItem = this.state.newItem;
    const error = this.state.error;
    const mcqData = this.state.mcqData;
    const compilerData = this.state.compilerData;
    const { filter } = this.props.assessmentQuestion;
    const boilerPlateArr = this.state.boilerPlate;
    const solutionCode = this.state.solutionCode;

    let isValid = true;

    function isInvalid(key, value) {
      error[key] = value;
      isValid = false;
    }

    if (question_title.trim() === '') isInvalid('question_title', 'Please enter title');

    if (newItem.category === true) {
      if (newCategory.trim() === '') {
        isInvalid('newCategory', 'Please enter new category');
      } else if (filter && filter.category && filter.category.length > 0) {
        for (let x = 0; x < filter.category.length; x++) {
          if (filter.category[x] && filter.category[x].category_name && filter.category[x].category_name.trim().toLowerCase() === newCategory.trim().toLowerCase()) {
            isInvalid('newCategory', 'New category already exist');
          }
        }
      }
    } else {
      if (master_skill_id === '') isInvalid('master_skill_id', 'Please select category');
    }

    // sql_questions_staging has no topic column, so a topic is not required
    // for SQL questions.
    if (question_type_code !== 'SQL') {
      if (newItem.topic === true) {
        if (newTopic.trim() === '') {
          isInvalid('newTopic', 'Please enter new topic');
        } else if (filter && filter.topic && filter.topic.length > 0) {
          for (let x = 0; x < filter.topic.length; x++) {
            if (filter.topic[x] && filter.topic[x].topic_name && filter.topic[x].topic_name.trim().toLowerCase() === newTopic.trim().toLowerCase()) {
              isInvalid('newTopic', 'New topic already exist');
            }
          }
        }
      } else {
        if (topic_id === '') isInvalid('topic_id', 'Please select topic');
      }
    }

    if (difficulty_level === '') isInvalid('difficulty_level', 'Please select difficulty');
    if (question_type_id === '' || question_type_code === '') isInvalid('question_type_id', 'Please select question type');
    if (question_type_code === 'MCQ') {
      let answered = false;
      let isOptionValid = true;
      for (let x = 0; x < mcqData.length; x++) {
        if (answered === false) answered = mcqData[x].is_correct;
        if (mcqData[x].option.trim() === '') isOptionValid = false;
      }
      if (isOptionValid === false) isInvalid('options', 'Empty option not accepted');
      else if (answered === false) isInvalid('options', 'Please select correct option');
    } else if (question_type_code === 'COMPILER') {
      let isTestCaseValid = true;
      for (let x = 0; x < compilerData.length; x++) {
        let { std_input, std_output, base64_folder, type } = compilerData[x];
        if (type == 'CONSOLE') {
          if (std_input.toString().trim() == '' || std_output.toString().trim() == '') {
            isTestCaseValid = false;
            break;
          }
        } else if (type == 'FILEREAD') {
          if (base64_folder == '') {
            isTestCaseValid = false;
            break;
          }
        }
      }
      if (isTestCaseValid === false) isInvalid('testCase', 'Empty input or output not accepted');
    } else if (question_type_code === 'SQL') {
      const { test_cases, solution_query } = this.state.sqlData;
      let message = '';

      if (solution_query.trim() === '') {
        message = 'A reference solution query is required';
      } else if (!test_cases.length) {
        message = 'At least one test case is required';
      }

      for (let x = 0; x < test_cases.length && message === ''; x++) {
        const tc = test_cases[x];
        const position = x + 1;
        const pasted = (tc.expected_result || '').trim();

        if (tc.schema_id === '') {
          message = `Test case ${position}: please select a schema`;
          break;
        }

        if (pasted !== '') {
          try {
            if (!Array.isArray(JSON.parse(pasted))) {
              message = `Test case ${position}: expected result must be a JSON array`;
            }
          } catch (e) {
            message = `Test case ${position}: expected result is not valid JSON`;
          }
        }
      }

      const selectedCount = (this.state.sqlData.selected_table_names || []).length;
      const hasSchemaSelected = test_cases.some((tc) => tc.schema_id !== '');
      if (message === '' && hasSchemaSelected && selectedCount === 0) {
        message = 'Select at least one table for the candidate preview';
      }
      if (message === '' && hasSchemaSelected && selectedCount > 0) {
        const previewRows = this.buildSelectedSchemaPreview(
          this.getSchemaTablePool(this.state.sqlData),
          this.state.sqlData.selected_table_names
        );
        if (!previewRows.length) {
          message = 'Tables selection could not be saved — re-select a schema above so tables reload, then check the ones you want';
        }
      }

      if (message !== '') isInvalid('sqlTestCase', message);
    }else if(question_type_code==='BASH'){
      const bashData = this.state.bashData;
      let message = '';

      if (!bashData || !bashData.question_folder) message = 'Please upload the question folder';
      else if (!bashData.grader_path_s3) message = 'grader/grader.sh is missing in the uploaded folder';
      else if (!bashData.test_cases.length) message = 'The uploaded folder has no test cases';
      else if (bashData.test_cases.some((tc) => !tc.result_file_s3)) message = 'Every test case folder needs an expected.txt';
      else if (!bashData.grader_check_passed) message = 'Run the grader check and make sure all cases pass before saving';

      if (message !== '') isInvalid('bashTestCase', message);
    } else if (question_type_code === 'ORDERING') {
      const steps = this.state.orderingData?.steps || [];
      const candidateOrder = this.state.orderingData?.candidateOrder || [];
      const correctIds = steps.map((_, index) => String.fromCharCode(97 + index));
      const hasEmptyStep = steps.some((step) => this.orderingStepText(step) === '');
      const sameAsCorrect = candidateOrder.length === correctIds.length
        && candidateOrder.every((opt, index) => String(opt.id) === correctIds[index]);
      const selectedCount = this.state.orderingData?.stepCount || steps.length;
      if (steps.length < 4 || steps.length > 6 || hasEmptyStep) {
        isInvalid('options', `Enter ${selectedCount} options`);
      } else if (!candidateOrder.length || sameAsCorrect) {
        isInvalid('options', 'Shuffle the steps before saving');
      }
    }

    if ((owners === 'BOOTCAMP' || owners === 'RECRUITER') && owners_id === '') {
      isInvalid('owners_id', `Please select ${owners}`)
    }

    if (isValid === true) {
      const question = this.state.question;
      if (question_type_code === 'MCQ') {
        const question_data = {};
        question_data.options = [];
        question_data.correct_answer = [];

        for (let x = 0; x < mcqData.length; x++) {
          question_data.options.push({ index: x, option: mcqData[x].option });
          if (mcqData[x].is_correct === true) question_data.correct_answer.push(x);
        }
        question.question_data = question_data;
      } else if (question_type_code === 'ORDERING') {
        const steps = (this.state.orderingData?.steps || []).map((step) => String(step || '').trim());
        question.question_data = {
          options: this.state.orderingData.candidateOrder,
          correct_answer: steps.map((_, index) => String.fromCharCode(97 + index)),
        };
      } else if (question_type_code === 'COMPILER') {
        question.question_data = compilerData;
        let boilerPlatePayload = [];
        for (let i = 0; i < boilerPlateArr.length; i++) {
          let { id, name, languageCode, fileReaderFn, customInputFn, matchOutputFn, solutionFn, predefinedCode } = boilerPlateArr[i];

          let obj = { id, name, languageCode, fileReaderFn, customInputFn, matchOutputFn, solutionFn, predefinedCode }

          if (predefinedCode != "" || fileReaderFn != "" || customInputFn != "" || matchOutputFn != "" || solutionFn != "") {
            boilerPlatePayload.push(obj);
          }
        }
        question.boiler_plate = boilerPlatePayload;

        let { id, fileReaderFn, customInputFn, matchOutputFn, solutionFn, predefinedCode } = solutionCode;
        let solution_code_arr = [];
        let obj = { id, fileReaderFn, customInputFn, matchOutputFn, solutionFn, predefinedCode }

        if (predefinedCode != "" || fileReaderFn != "" || customInputFn != "" || matchOutputFn != "" || solutionFn != "") {
          solution_code_arr.push(obj);
        }

        question.solution_code = (solution_code_arr.length > 0 ? solution_code_arr : "");
      } else if (question_type_code === 'SQL') {
        const sqlData = this.state.sqlData;
        const marks = parseInt(sqlData.marks, 10);

        question.marks = isNaN(marks) ? 10 : marks;
        question.active = sqlData.active;
        question.starter_query = sqlData.starter_query;
        question.solution_query = sqlData.solution_query;
        question.hints = sqlData.hints.filter((hint) => hint.trim() !== '');
        {
          const pool = this.getSchemaTablePool(sqlData);
          question.schema_preview = this.buildSelectedSchemaPreview(
            pool,
            sqlData.selected_table_names
          );
        }
        question.test_cases = this.syncSqlTestCaseCodes(sqlData.test_cases).map((tc) => {
          const pasted = (tc.expected_result || '').trim();
          return {
            schema_id: tc.schema_id,
            test_case_code: tc.test_case_code,
            is_hidden: tc.is_hidden === true,
            title: tc.title,
            description: tc.description,
            // null tells the backend to generate this case from solution_query
            expected_result: pasted === '' ? null : JSON.parse(pasted),
          };
        });
      } else if(question_type_code === 'BASH'){
        const bashData = this.state.bashData;
        
        question.active = bashData.active;
        question.question_folder = bashData.question_folder;
        question.grader_path_s3 = bashData.grader_path_s3;
        question.grader_path_container = bashData.grader_path_container;
        question.run_command = bashData.run_command;
        question.support_files = bashData.support_files;
        question.hints = bashData.hints;
        question.sample_explanation = bashData.sample_explanation;
        question.test_cases = bashData.test_cases;
      }

      if (newItem.category === true) {
        question.category_name = question.newCategory;
        question.master_skill_id = '';
      }
      if (newItem.topic === true) {
        question.topic_name = question.newTopic;
        question.topic_id = '';
      }

      delete question.newCategory;
      delete question.newTopic;

      if (this.state.pageMode === 'edit' && typeof question_id !== 'undefined') {
        question.question_id = question_id;
      }

      if (owners === 'BOOTCAMP' || owners === 'RECRUITER') {
        question.company_id = `${question.owners_id}`;
        question.owners=`${owners}`
      }else if(owners === 'PRACTICE' ){
        question.owners = 'PRACTICE';
      } else {
        question.owners = 'COFFEEE';
      }
      delete question.owners_id;

      this.props.addRequest(question, this.state.pageMode);
    } else {
      this.setState({ error });
    }
  }

  checkboxChange = (e) => {
    const { id, checked } = e.target;
    const question = this.state.question;
    question[id] = checked;
    this.setState({ question });
  }

  ownerTypeChange = (id) => {
    let question = this.state.question;
    if (question.owners !== id) {
      question.owners = id;
      question.owners_id = '';

      const error = this.state.error;
      error.owners_id = '';

      question.is_bootcamp = id === 'BOOTCAMP' ? true : false;

      if (id === 'BOOTCAMP' || id === 'RECRUITER') {
        this.props.ownerRequest(id);
      } else if (id==='PRACTICE'){
        this.props.ownerRequest(id);
      }
      this.setState({ question, error })
    }
  }

  setBoilerPlateCode = (e, key) => {
    const { id, value } = e.target;
    const boilerPlateArr = this.state.boilerPlate;
    boilerPlateArr[id][key] = value;
    this.setState({boilerPlate: boilerPlateArr});
  }


  setSolutionCode = (e, key) => {
    let solutionCode = this.state.solutionCode;
    solutionCode[key] = e.target.value;
    this.setState({ solutionCode })
  }

  concatCode = (a, b, c) => {
    return (a + "\n\n" + b + "\n\n" + c);
  }

  setCustomInput = (e, boilerPlateIdx, type) => {
    if (type == "boilerPlate") {
      const boilerPlateArr = this.state.boilerPlate;
      boilerPlateArr[boilerPlateIdx].custom_input = e.target.value;
      this.setState({boilerPlate: boilerPlateArr});

    } else if (type == "solutionCode") {
      const solutionCode = this.state.solutionCode;
      solutionCode.custom_input = e.target.value;
      this.setState({ solutionCode });
    }
  }

  validateSolutionCode_MedHard = async () => {
    let solutionCode = this.state.solutionCode;
    try {
      solutionCode.loader = true;
      solutionCode.outputResult = [];
      solutionCode.error = "";
      this.setState({ solutionCode });
      if (!solutionCode.id || solutionCode.id == '' || solutionCode.id == undefined) {
        return;
      }

      let { fileReaderFn, customInputFn, matchOutputFn, solutionFn, compileMode, custom_input, id } = this.state.solutionCode;
      let source_code;
      let requestPayload;

      if (compileMode == "fileread") {
          if (id == 71) {
            // python
            source_code = this.concatCode(solutionFn, matchOutputFn, fileReaderFn);
          } else {
            source_code = this.concatCode(fileReaderFn, matchOutputFn, solutionFn);
          }
          requestPayload = {
            "question_id": this.state.question.question_id,
            "language_id": solutionCode.id,
            "source_code": source_code
          }

      } else if (compileMode == "custominput") {
        if (id == 71) {
          // python
          source_code = this.concatCode(solutionFn, "", customInputFn);
        } else {
          source_code = this.concatCode(customInputFn, "", solutionFn);
        }
        requestPayload = {
          "question_id": this.state.question.question_id,
          "language_id": solutionCode.id,
          "source_code": source_code,
          "custom_input": base64.encode(custom_input)
        }
      }

      let url;
      if (compileMode == "fileread") {
        url = 'compile-code';
      } else if (compileMode == "custominput") {
        url = 'compile-custom-input';
      }

      let response = await this.compileCodeApiCall(requestPayload, url);
      let data = response?.data?.data?.test_cases_result;
      solutionCode.outputResult = data;
      solutionCode.loader = false;
      this.setState({ solutionCode });

    } catch (e) {
      solutionCode.loader = false;
      let errorMessage = e?.response?.data?.meta?.message;
      solutionCode.error = errorMessage;
      solutionCode.outputResult = [];
      this.setState({ solutionCode });
    }
  }

  validateSolutionCode_Easy = async () => {
    let solutionCode = this.state.solutionCode;
    solutionCode.loader = true;
    solutionCode.error = "";
    solutionCode.outputResult = [];
    this.setState({ solutionCode });
    if (!solutionCode.id || solutionCode.id == '' || solutionCode.id == undefined) {
      return;
    }

    let requestPayload = {
      "question_id": this.state.question.question_id,
      "language_id": solutionCode.id,
      "source_code": base64.encode(solutionCode.predefinedCode)
    }

    let response = await this.compileCodeApiCall(requestPayload, 'compile-code-easy');
    let data = response?.data?.data?.test_cases_result;
    solutionCode.outputResult = data;
    solutionCode.loader = false;
    this.setState({ solutionCode });
  }

  validateDefaultCode_MedHard = async (e, boilerPlateIdx) => {
    const boilerPlateArr = this.state.boilerPlate;
    try {
      boilerPlateArr[boilerPlateIdx].compileLoader = true;
      boilerPlateArr[boilerPlateIdx].outputResult = [];
      boilerPlateArr[boilerPlateIdx].error = "";
      this.setState({boilerPlate: boilerPlateArr});


      let { fileReaderFn, customInputFn, matchOutputFn, solutionFn, compileMode, custom_input, id } =  boilerPlateArr[boilerPlateIdx];

      let source_code;
      let requestPayload;

      if (compileMode == "fileread") {
        if (id == 71) {
          // python
          source_code = this.concatCode(solutionFn, matchOutputFn, fileReaderFn);
        } else {
          source_code = this.concatCode(fileReaderFn, matchOutputFn, solutionFn);
        }
        requestPayload = {
          "question_id": this.state.question.question_id,
          "language_id": id,
          "source_code": source_code
        }

      } else if (compileMode == "custominput") {
        if (id == 71) {
          // python
          source_code = this.concatCode(solutionFn, "", customInputFn);
        } else {
          source_code = this.concatCode(customInputFn, "", solutionFn);
        }
        requestPayload = {
          "question_id": this.state.question.question_id,
          "language_id": id,
          "source_code": source_code,
          "custom_input": base64.encode(custom_input)
        }
      }


      let url;
      if (compileMode == "fileread") {
        url = 'compile-code';
      } else if (compileMode == "custominput") {
        url = 'compile-custom-input';
      }
      let response = await this.compileCodeApiCall(requestPayload, url);
      let data = response?.data?.data?.test_cases_result;
      boilerPlateArr[boilerPlateIdx].outputResult = data;
      boilerPlateArr[boilerPlateIdx].compileLoader = false;
      this.setState({ boilerPlate: boilerPlateArr });

    } catch (e) {
      let errorMessage = e?.response?.data?.meta?.message;
      boilerPlateArr[boilerPlateIdx].compileLoader = false;
      boilerPlateArr[boilerPlateIdx].error = errorMessage;
      boilerPlateArr[boilerPlateIdx].outputResult = [];
      this.setState({ boilerPlate: boilerPlateArr });
    }

  }

  validateDefaultCode_Easy = async (e, boilerPlateIdx) => {
    const boilerPlateArr = this.state.boilerPlate;
    boilerPlateArr[boilerPlateIdx].compileLoader = true;
    boilerPlateArr[boilerPlateIdx].outputResult = [];
    boilerPlateArr[boilerPlateIdx].error = "";

    this.setState({boilerPlate: boilerPlateArr});

    let requestPayload = {
      "question_id": this.state.question.question_id,
      "language_id": boilerPlateArr[boilerPlateIdx].id,
      "source_code": base64.encode(boilerPlateArr[boilerPlateIdx].predefinedCode)
    }

    let response = await this.compileCodeApiCall(requestPayload, 'compile-code-easy');
    let data = response?.data?.data?.test_cases_result;
    boilerPlateArr[boilerPlateIdx].outputResult = data;
    boilerPlateArr[boilerPlateIdx].compileLoader = false;
    this.setState({ boilerPlate: boilerPlateArr });
  }


  // final version
  validateCode = async (boilerPlateIdx, type) => {
    let obj = null;
    let loaderKey = null;
    if (type == "boilerPlate") {
      obj = this.state.boilerPlate[boilerPlateIdx];
      loaderKey = "compileLoader";
    } else if (type == "solutionCode") {
      obj = this.state.solutionCode;
      loaderKey = "loader";
    }
    obj[loaderKey] = true;
    obj.outputResult = [];
    this.setState({ type: obj });


    let predefinedCode = "";
    let consoleinput_code = "";
    let filereader_code = "";
    let compile_mode = "";

    let { difficulty_level } = this.state.question;
    if (difficulty_level == "EASY") {
      predefinedCode = obj.predefinedCode;
      consoleinput_code = obj.predefinedCode;
      compile_mode = "RUN_TESTCASES";

    } else if (difficulty_level == "MEDIUM" || difficulty_level == "HARD") {
      predefinedCode = obj.solutionFn;
      compile_mode = (obj.compileMode == 'fileread' ? "RUN_TESTCASES" : "RUN_CUSTOMINPUT");

      if (obj.id == 71) {
        filereader_code = obj.solutionFn + "\n\n" + obj.matchOutputFn + "\n\n" + obj.fileReaderFn;
        consoleinput_code = obj.solutionFn + "\n\n" + obj.matchOutputFn + "\n\n" + obj.customInputFn;
      } else {
        filereader_code = obj.fileReaderFn + "\n\n" + obj.matchOutputFn + "\n\n" + obj.solutionFn;
        consoleinput_code = obj.customInputFn + "\n\n" + obj.matchOutputFn + "\n\n" + obj.solutionFn;
      }
    }



    let payload = {
      question_id: this.state.question.question_id,
      language_id: obj.id,
      predefinedCode,
      compile_mode,
      custom_input: obj.custom_input,
      admin_as_source: true,
      filereader_code,
      consoleinput_code
    }

    let response = await this.compileCodeApiCall(payload, 'compile-code');
    let data = response?.data?.data?.test_cases_result;
    obj.outputResult = data;
    obj[loaderKey] = false;

    this.setState({ type: obj });
  }

  compileCodeApiCall = (data, url) => {
    let axiosRequestOptions = {
      headers: {
        authorization: localStorage.getItem("jwtToken"),
        'Content-Type': 'application/json'
        },
      };
      return axios.post(
        `${process.env.REACT_APP_API_PATH}judge0/${url}`,
        data,
        axiosRequestOptions
      );
  }

  uploadTestCase = async () => {
    let { question, compilerData, testCaseLoader } = this.state;
    let { difficulty_level } = question;
    let error = this.state.error;

    let isTestCaseValid = true;
    for (let i = 0; i < compilerData.length; i++) {
      let { std_input, std_output, base64_folder, type } = compilerData[i];
      if (type == 'CONSOLE') {
        if (std_input.toString().trim() == '' || std_output.toString().trim() == '') {
          isTestCaseValid = false;
          break;
        }
      } else if (type == 'FILEREAD') {
        if (base64_folder == '') {
          isTestCaseValid = false;
          break;
        }
      }
    }
    if (isTestCaseValid === false) {
      error["testCase"] = "Empty input or output not accepted";
      this.setState({ error });
      return;

    }

    testCaseLoader = true;
    this.setState({ testCaseLoader });

    let requestPayload = {
      "test_cases": compilerData,
      "difficulty": difficulty_level,
      "question_id": question.question_id
    }

    let axiosRequestOptions = {
      headers: {
        authorization: localStorage.getItem("jwtToken"),
        'Content-Type': 'application/json'
      }
    };

    let result = await axios.post(
      `${process.env.REACT_APP_API_PATH}assessments/upload-testcases`,
      requestPayload,
      axiosRequestOptions
    );

    testCaseLoader = false;
    this.setState({ compilerData: result?.data?.data, testCaseLoader });

  }

  toggleCompileMode = (e, boilerPlateIdx, type) => {
    if (type == 'boilerPlate') {
      let boilerPlateArr = this.state.boilerPlate;
      let compileMode = boilerPlateArr[boilerPlateIdx].compileMode;
      if (compileMode == 'fileread') {
        compileMode = 'custominput'
      } else if (compileMode == 'custominput') {
        compileMode = 'fileread';
      }
      boilerPlateArr[boilerPlateIdx].compileMode = compileMode;
      this.setState({ boilerPlate: boilerPlateArr });

    } else if (type == 'solutionCode') {

      let solutionCode = this.state.solutionCode;
      let compileMode = solutionCode.compileMode;
      if (compileMode == 'fileread') {
        compileMode = 'custominput'
      } else if (compileMode == 'custominput') {
        compileMode = 'fileread';
      }
      solutionCode.compileMode = compileMode;
      this.setState({ solutionCode });
    }
  }

  handleUploadTestCaseFolder = async (e, obj, objIndex) => {
    let compilerData = this.state.compilerData;
    let files = e.target.files;
    let zip = new JSZip();
    let archive = zip.folder("inputOutputFiles");
    for (let i = 0; i < files.length; i++) {
      archive.file(files[i].name, files[i], { binary: true });
    }
    let base64 = await archive.generateAsync({ type: "base64" });
    compilerData[objIndex].base64_folder = base64;
    this.setState({ compilerData });
  }

  toggleTestCase = (optIndex) => {
    let { compilerData } = this.state;
    let obj = compilerData[optIndex];
    let type = obj.type;
    if (type == 'CONSOLE') {
      obj.type = 'FILEREAD';
    } else if (type = 'FILEREAD') {
      obj.type = 'CONSOLE';
    }
    obj.std_input = '';
    obj.std_output = '';
    obj.execution_time = '';
    obj.zip_folder_link = '';
    obj.base64_folder = '';

    compilerData[optIndex] = obj;

    this.setState({ compilerData });
  }
  QuestionImageHandler = (e) => {
    const {question, error} = this.state;
    const image = e.target.files[0];
    const fileExtensionText = image.name.split('.');
    const fileExtension = fileExtensionText[fileExtensionText.length-1];
    if (fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg') {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        question.question_image = fileReader.result;
        // error.cover_image = '';
        this.setState({ error });
        this.setState({ question });

      }, false);
      fileReader.readAsDataURL(image);
    } else {
      // error.cover_image = 'Upload File In Required Format!';
      question.question_image = null;
      // this.setState({ error });
      this.setState({ test });
    }
  }
  handleImageChange = (e, optIndex) => {
    const file = e.target.files[0];
    const reader = new FileReader();
  
    reader.onloadend = () => {
      const mcqData = [...this.state.mcqData];
      mcqData[optIndex].image_url = reader.result;
      this.setState({ mcqData });
    };
  
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  

  render () {
    const { difficulty, newItem, question, error, mcqData, orderingData, compilerData, pageMode, ownerTypes, boilerPlate, solutionCode, testCaseLoader, sqlData, sqlSchemas, sqlSchemaForm, sqlSchemaAppendForm, sqlSchemaRowsForm } = this.state;
    const { filter } = this.props.assessmentQuestion;
    const { addQuestionLoading, owners, addQuestion } = this.props.addAssessmentQuestion;
    // handleApiErrors inspects the fetch Response, not the parsed body, so a
    // rejected save resolves normally. Surface the server message instead of
    // leaving the form looking like nothing happened.
    const saveError = addQuestion && addQuestion.code !== 200 ? addQuestion.message : '';
    console.log("question type",filter,question)
    let heading = 'Question';
    if (pageMode !== '') {
      heading = pageMode === 'edit' ? 'Edit Question' : 'New Question';
    }
    return (
      <Styled.MainDiv>
        <Loader show={addQuestionLoading} heading={pageMode === 'edit' ? 'Updating Question' : 'Adding Question'} />
        <Sidemenu />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>

            <Styled.ContentDiv>
              <Styled.PageHeader>
                <Styled.BackLink to="/assessment-question">← Back to Questions</Styled.BackLink>
                <Styled.PageTitle>{heading}</Styled.PageTitle>
                <Styled.PageSubtitle>
                  {pageMode === 'edit'
                    ? 'Update question metadata, content, and answer configuration.'
                    : 'Fill in the details below to create a new question.'}
                </Styled.PageSubtitle>
              </Styled.PageHeader>

              { typeof filter !== 'undefined' ?
                <Styled.CardDiv>
                  <Styled.FormBody>
                    <Styled.FormSection>
                      <Styled.SectionHeader>
                        <Styled.SectionTitle>Basic Information</Styled.SectionTitle>
                        <Styled.SectionDescription>Title, type, skill, topic, and difficulty level.</Styled.SectionDescription>
                      </Styled.SectionHeader>

                      <Styled.InputWrap error={error.question_title !== ''}>
                        <Styled.InputTitleDiv>Question Title</Styled.InputTitleDiv>
                        <input type="text" id="question_title" placeholder="Enter Question Title" value={question.question_title} onChange={(e) => this.inputChange(e)} />
                        <Styled.InputErrorDiv>{error.question_title}</Styled.InputErrorDiv>
                      </Styled.InputWrap>

                      <Styled.FormRow style={{ marginTop: '20px' }}>
                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Question Type</Styled.InputTitleDiv>
                          <Dropdown title="Select Question Type" list={filter.question_type} value="id" name="question_type_id" selected={this.dropdownChange} width="100%" height="48px" option="question_type_name" active={question} error={error.question_type_id !== ''} />
                          <Styled.InputErrorDiv>{error.question_type_id}</Styled.InputErrorDiv>
                        </Styled.InputWrap>

                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Difficulty Level</Styled.InputTitleDiv>
                          <Dropdown title="Select Difficulty Level" list={difficulty} value="id" name="difficulty_level" selected={this.dropdownChange} width="100%" height="48px" option="title" active={question} error={error.difficulty_level !== ''} />
                          <Styled.InputErrorDiv>{error.difficulty_level}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      </Styled.FormRow>

                      <Styled.FormRow style={{ marginTop: '20px' }}>
                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Skill</Styled.InputTitleDiv>
                          <Styled.InputWithAction>
                            <Dropdown title="Select Skills" list={filter.category} value="id" name="master_skill_id" 
                            selected={this.dropdownChange} 
                            width="100%" height="48px" option="category_name" 
                            active={question} 
                            error={error.master_skill_id !== ''}
                            searchable />
                            <Styled.InputNewButton onClick={() => this.addNewQuestion('category')}>{newItem.category === true ? '-' : '+'}</Styled.InputNewButton>
                          </Styled.InputWithAction>
                          <Styled.InputErrorDiv>{error.master_skill_id}</Styled.InputErrorDiv>
                        </Styled.InputWrap>

                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Topics</Styled.InputTitleDiv>
                          <Styled.InputWithAction>
                            <Dropdown title="Select Topic" 
                            list={filter.topic} value="id" 
                            name="topic_id" 
                            selected={this.dropdownChange} 
                            width="100%" height="48px" option="topic_name" 
                            active={question} error={error.topic_id !== ''} searchable />
                            <Styled.InputNewButton onClick={() => this.addNewQuestion('topic')}>{newItem.topic === true ? '-' : '+'}</Styled.InputNewButton>
                          </Styled.InputWithAction>
                          <Styled.InputErrorDiv>{error.topic_id}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      </Styled.FormRow>

                      { newItem.category === true ?
                        <Styled.InputWrap error={error.newCategory !== ''} style={{ marginTop: '20px' }}>
                          <Styled.InputTitleDiv>New Skill</Styled.InputTitleDiv>
                          <input type="text" id="newCategory" placeholder="Enter Skill" value={question.newCategory} onChange={(e) => this.inputChange(e)} />
                          <Styled.InputErrorDiv>{error.newCategory}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      : ''
                      }

                      { newItem.topic === true ?
                        <Styled.InputWrap error={error.newTopic !== ''} style={{ marginTop: '20px' }}>
                          <Styled.InputTitleDiv>New Topic Name</Styled.InputTitleDiv>
                          <input type="text" id="newTopic" placeholder="Enter Topic Name" value={question.newTopic} onChange={(e) => this.inputChange(e)} />
                          <Styled.InputErrorDiv>{error.newTopic}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      : ''
                      }
                    </Styled.FormSection>

                    <Styled.FormSection>
                      <Styled.SectionHeader>
                        <Styled.SectionTitle>Question Content</Styled.SectionTitle>
                        <Styled.SectionDescription>Question body and ownership settings.</Styled.SectionDescription>
                      </Styled.SectionHeader>

                      {(question.question_type_code ==='COMPILER') ?
                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Question Details</Styled.InputTitleDiv>
                          <textarea rows="8" id="question_details" placeholder="Enter details..." value={question.question_details} onChange={(e) => this.inputChange(e)} />
                          <Styled.InputErrorDiv></Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      :
                        <Styled.InputWrap>
                          <Styled.InputTitleDiv>Question Details</Styled.InputTitleDiv>
                          <RichQuestionEditor height="200px" width="100%" id="question_details" placeholder="Question Details" value={question.question_details} change={this.editorInputChange} />
                          <Styled.InputErrorDiv></Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      }
                  {
          //           question.question_type_code === 'MCQ' ?(
          //             <Styled.InputWrap>
          //                <Styled.InputTitleDiv>Question Image</Styled.InputTitleDiv>
          //             <Styled.CoverImageWrapDiv>
          //             <div style={{ fontSize: '16px', marginBottom: '8px' }}>Upload Question Image</div>
          //             <div style={{ opacity: '0.6', marginBottom: '4px' }}>Image size: 650x861</div>
          //             <div style={{ opacity: '0.6', marginBottom: '15px' }}>Image formats (PNG, JPEG, SVG or JPG)</div>

          //             {/* { test?.test_cover_url?.length>0 || test?.cover_image ?
          //                 <img src={test.cover_image?test.cover_image:test.test_cover_url} style={{width: '100px', height: '100px', margin: '0 auto 15px'}} />:''
          //               } */}
          //  { question?.question_image?<img src={question?.question_image} style={{width: '200px', height: '120px', margin: '0 auto 15px',objectFit:'contain'}} />:null}
          //             {/* { error.cover_logo &&
          //               <Styled.SaveErrorDiv style={{marginBottom: '15px'}}>{error.cover_logo}</Styled.SaveErrorDiv>
          //             } */}

          //             <Styled.CoverImageLabel htmlFor='cover-logo'>
          //               <img src={uploadIcon} alt=''/>Upload Question Image
          //               <Styled.CoverImageInput
          //                 id='cover-logo'
          //                 type='file'
          //                 accept='image/png, image/jpeg, image/jpg'
          //                 onChange={this.QuestionImageHandler}
          //                 name='cover_logo'
          //               />
          //             </Styled.CoverImageLabel>
          //           </Styled.CoverImageWrapDiv>
          //           </Styled.InputWrap>
          //           ):null
                  }

                      <Styled.OwnersWrap>
                        <Styled.InputTitleDiv>Owner Type</Styled.InputTitleDiv>
                        <RadioButton list={ownerTypes} value="id" name="owners" option="title" selected={this.ownerTypeChange} width="100%" rowItemCount={4} active={question} />
                      </Styled.OwnersWrap>

                      { (question.owners === 'BOOTCAMP' || question.owners === 'RECRUITER') ?
                        <Styled.InputWrap style={{ marginTop: '20px' }}>
                          <Styled.InputTitleDiv>{`${question.owners === 'BOOTCAMP' ? 'Bootcamp' : 'Recruiter'}s`}</Styled.InputTitleDiv>
                          <Dropdown title={`Select ${question.owners === 'BOOTCAMP' ? 'Bootcamp' : 'Recruiter'} Type`} list={owners && owners.data ? owners.data : []} value="id" name="owners_id" selected={this.dropdownChange} width="100%" height="48px" option="title" active={question} error={error.owners_id !== ''} />
                          <Styled.InputErrorDiv>{error.owners_id}</Styled.InputErrorDiv>
                        </Styled.InputWrap>
                      : ''
                      }
                    </Styled.FormSection>
                  </Styled.FormBody>

                  { question.question_type_code === 'MCQ' ?
                    <Styled.GreyBoxDiv>
                      <Styled.GreyBoxHeader>
                        <Styled.GreyBoxTitle>Answer Options</Styled.GreyBoxTitle>
                        <Styled.GreyBoxHint>Mark one option as correct — editor spans full width below each option label</Styled.GreyBoxHint>
                      </Styled.GreyBoxHeader>

                      <Styled.McqOptionsList>
                        { mcqData.map((opt, optIndex) => (
                          <Styled.McqOptionCard key={optIndex} active={opt.is_correct}>
                            <Styled.McqOptionToolbar active={opt.is_correct}>
                              <Styled.McqOptionToolbarLeft>
                                <Styled.McqCorrectToggle
                                  type="button"
                                  onClick={() => this.selectOption(optIndex)}
                                  title="Mark as correct answer"
                                >
                                  <Styled.McqRadioOuter active={opt.is_correct}>
                                    <Styled.McqRadioInner active={opt.is_correct} />
                                  </Styled.McqRadioOuter>
                                  <Styled.McqOptionTitle>Option {optIndex + 1}</Styled.McqOptionTitle>
                                </Styled.McqCorrectToggle>
                                { opt.is_correct ? <Styled.McqCorrectBadge>Correct answer</Styled.McqCorrectBadge> : null }
                              </Styled.McqOptionToolbarLeft>
                              <Styled.McqOptionToolbarRight>
                                { optIndex > 1 ?
                                  <Styled.DeleteIconButton
                                    onClick={() => this.deleteOption(optIndex)}
                                    tabIndex="-1"
                                    title="Delete option"
                                  >
                                    <img src={deleteIcon} alt="delete option" />
                                  </Styled.DeleteIconButton>
                                : null }
                              </Styled.McqOptionToolbarRight>
                            </Styled.McqOptionToolbar>

                            <Styled.McqOptionEditorWrap>
                              <RichQuestionEditor
                                id={optIndex}
                                compact
                                placeholder={`Write option ${optIndex + 1} content here...`}
                                value={opt.option}
                                height={130}
                                width="100%"
                                change={this.changeOption}
                              />
                            </Styled.McqOptionEditorWrap>
                          </Styled.McqOptionCard>
                        )) }
                      </Styled.McqOptionsList>

                      <Styled.McqFooter>
                        <Styled.NewOptionButton onClick={this.addNewOption}>+ Add option</Styled.NewOptionButton>
                        <Styled.McqFooterHint>{mcqData.length} options · click radio to set correct answer</Styled.McqFooterHint>
                        <Styled.InputErrorDiv style={{ padding: '0px' }}>{error.options}</Styled.InputErrorDiv>
                      </Styled.McqFooter>
                    </Styled.GreyBoxDiv>
                  : ''
                  }

                  { question.question_type_code === 'ORDERING' ?
                    <Styled.GreyBoxDiv>
                      <Styled.GreyBoxHeader>
                        <Styled.GreyBoxTitle>Ordering Steps</Styled.GreyBoxTitle>
                        <Styled.GreyBoxHint>Enter 4 to 6 steps in the correct order, then shuffle the order candidates will see</Styled.GreyBoxHint>
                      </Styled.GreyBoxHeader>
                      <Styled.StepCountRow>
                        <Styled.StepCountLabel>No. of Steps</Styled.StepCountLabel>
                        <Styled.StepRangeWrap>
                          <input
                            type="range"
                            min="4"
                            max="6"
                            step="1"
                            value={orderingData?.stepCount || 4}
                            onChange={(e) => this.setOrderingStepCount(e.target.value)}
                          />
                          <Styled.StepRangeMarks>
                            {[4, 5, 6].map((count) => (
                              <button
                                key={count}
                                type="button"
                                data-active={String((orderingData?.stepCount || 4) === count)}
                                onClick={() => this.setOrderingStepCount(count)}
                              >
                                {count}
                              </button>
                            ))}
                          </Styled.StepRangeMarks>
                        </Styled.StepRangeWrap>
                      </Styled.StepCountRow>
                      <Styled.McqOptionsList>
                        {(orderingData?.steps || []).map((step, stepIndex) => (
                          <Styled.McqOptionCard key={stepIndex}>
                            <Styled.McqOptionToolbar>
                              <Styled.McqOptionToolbarLeft>
                                <Styled.McqOptionTitle>{`Step ${stepIndex + 1}`}</Styled.McqOptionTitle>
                              </Styled.McqOptionToolbarLeft>
                            </Styled.McqOptionToolbar>
                            <Styled.OrderingStepInput
                              value={step}
                              rows={2}
                              placeholder={`Write step ${stepIndex + 1} in the correct order...`}
                              onChange={(event) => this.changeOrderingStep(stepIndex, event.target.value)}
                            />
                          </Styled.McqOptionCard>
                        ))}
                      </Styled.McqOptionsList>
                      <Styled.McqFooter>
                        <Styled.NewOptionButton type="button" onClick={this.shuffleOrderingSteps}>Shuffle</Styled.NewOptionButton>
                        <Styled.McqFooterHint>Candidates never see the order typed above</Styled.McqFooterHint>
                        <Styled.InputErrorDiv style={{ padding: '0px' }}>{error.options}</Styled.InputErrorDiv>
                      </Styled.McqFooter>
                      {(orderingData?.candidateOrder || []).length > 0 ?
                        <Styled.OrderingPreview>
                          <Styled.InputTitleDiv>Order for candidates</Styled.InputTitleDiv>
                          {orderingData.candidateOrder.map((step, stepIndex) => {
                            const correctAnswer = orderingData.correctAnswer || [];
                            const correctPlace = correctAnswer.indexOf(String(step.id));
                            const stepNumber = correctPlace >= 0 ? correctPlace + 1 : stepIndex + 1;
                            return (
                              <Styled.OrderingPreviewRow key={`${step.id}-${stepIndex}`}>
                                <Styled.OrderingPreviewIndex>{stepNumber}.</Styled.OrderingPreviewIndex>
                                <Styled.OrderingPreviewText>{step.option}</Styled.OrderingPreviewText>
                              </Styled.OrderingPreviewRow>
                            );
                          })}
                        </Styled.OrderingPreview>
                      : null}
                    </Styled.GreyBoxDiv>
                  : ''
                  }

                  { question.question_type_code === 'COMPILER' ?
                    <Styled.GreyBoxDiv>
                      <Styled.GreyBoxHeader>
                        <Styled.GreyBoxTitle>Compiler Question</Styled.GreyBoxTitle>
                        <Styled.GreyBoxHint>Test cases, boilerplate, and solution code</Styled.GreyBoxHint>
                      </Styled.GreyBoxHeader>

                      <Styled.SubSectionTitle>Test Cases</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>Define input/output pairs and visibility for each test case</Styled.SubSectionHint>

                      <Styled.TestCaseTable>
                        <Styled.TestCaseTableHeader>
                          <span>#</span>
                          <span>Input</span>
                          <span>Output</span>
                          <span>Visibility</span>
                          <span>Time</span>
                          <span>Actions</span>
                        </Styled.TestCaseTableHeader>

                        { compilerData.map((opt, optIndex) => (
                          <Styled.TestCaseRow key={optIndex}>
                            <Styled.TestCaseIndex>{optIndex + 1}</Styled.TestCaseIndex>

                            <Styled.TestCaseFieldGroup>
                              <Styled.TestCaseFieldLabel>Input</Styled.TestCaseFieldLabel>
                              { opt.type == 'CONSOLE' ?
                                <Styled.TestCaseTextArea
                                  value={opt.std_input}
                                  rows="4"
                                  placeholder="Standard input..."
                                  onChange={(e) => this.changeTestCase(e, optIndex, 'std_input')}
                                />
                              : opt.type == 'FILEREAD' ?
                                <Styled.FileReadRow>
                                  <Styled.UploadTestCaseLabel>
                                    Upload Test Case Folder
                                    <input type="file" webkitdirectory="true" onChange={(e) => this.handleUploadTestCaseFolder(e, opt, optIndex)} />
                                  </Styled.UploadTestCaseLabel>
                                  <Styled.TestCaseTextArea
                                    value={opt.base64_folder}
                                    rows="3"
                                    readOnly
                                    placeholder="Uploaded folder (base64)..."
                                  />
                                </Styled.FileReadRow>
                              : ''
                              }
                            </Styled.TestCaseFieldGroup>

                            <Styled.TestCaseFieldGroup>
                              <Styled.TestCaseFieldLabel>Output</Styled.TestCaseFieldLabel>
                              { opt.type == 'CONSOLE' ?
                                <Styled.TestCaseTextArea
                                  value={opt.std_output}
                                  rows="4"
                                  placeholder="Expected output..."
                                  onChange={(e) => this.changeTestCase(e, optIndex, 'std_output')}
                                />
                              : <Styled.TestCaseTextArea rows="3" readOnly placeholder="Output from uploaded folder" />
                              }
                            </Styled.TestCaseFieldGroup>

                            <Styled.TestCaseControls>
                              <Styled.TestCaseFieldLabel>Visibility</Styled.TestCaseFieldLabel>
                              <Styled.VisibilityGroup>
                                <Styled.CheckboxDiv2 active={opt.visibility === 'PUBLIC'} onClick={() => this.selectCase(optIndex, 'PUBLIC')}>Public</Styled.CheckboxDiv2>
                                <Styled.CheckboxDiv2 active={opt.visibility === 'PRIVATE'} onClick={() => this.selectCase(optIndex, 'PRIVATE')}>Private</Styled.CheckboxDiv2>
                              </Styled.VisibilityGroup>
                            </Styled.TestCaseControls>

                            <Styled.TimeInputWrap>
                              <Styled.TestCaseFieldLabel>Time (sec)</Styled.TestCaseFieldLabel>
                              <Styled.TimeInput
                                type="text"
                                placeholder="Time"
                                value={opt.execution_time}
                                onChange={(e) => this.handleInputTime(e, optIndex, 'execution_time')}
                              />
                            </Styled.TimeInputWrap>

                            <Styled.TestCaseActions>
                              <Styled.TestCaseFieldLabel>Actions</Styled.TestCaseFieldLabel>
                              { optIndex > 1 ?
                                <Styled.DeleteIconButton onClick={() => this.deleteTestCase(optIndex)} tabIndex="-1" title="Delete Test Case">
                                  <img src={deleteIcon} alt="delete test case" />
                                </Styled.DeleteIconButton>
                              : ''
                              }
                              <Styled.TestCaseToggleButton onClick={() => this.toggleTestCase(optIndex)}>
                                Toggle {opt.type == "CONSOLE" ? "Console" : "File"} I/P
                              </Styled.TestCaseToggleButton>
                            </Styled.TestCaseActions>
                          </Styled.TestCaseRow>
                        )) }
                      </Styled.TestCaseTable>

                      <Styled.ActionRow>
                        <Styled.NewOptionButton onClick={this.addNewTestCase}>+ Add New Test Case</Styled.NewOptionButton>
                        {
                          question.question_id != "" ?
                            <Styled.UploadTestCases onClick={this.uploadTestCase}>
                              {
                                testCaseLoader ? <Buttonloader/> : "+ Upload Testcases"
                              }
                            </Styled.UploadTestCases>
                          : ''
                        }
                        <Styled.InputErrorDiv style={{ padding: '0px' }}>{error.testCase}</Styled.InputErrorDiv>
                      </Styled.ActionRow>

                      <Styled.SubSectionDivider>
                        <Styled.SubSectionTitle>Add Default Code</Styled.SubSectionTitle>
                        <Styled.SubSectionHint>Boilerplate code shown to candidates per language</Styled.SubSectionHint>
                      </Styled.SubSectionDivider>

                      {
                        boilerPlate.map((obj, idx) => (
                          <Styled.BoilerPlateWrap key={idx}>
                            <Styled.BoilerPlateName>{obj.languageCode} [{obj.name}]</Styled.BoilerPlateName>

                            <Styled.CompilerCodeRow>
                              <Styled.CompilerCodeMain>
                                <Styled.CodeAreaWrap>
                                  {
                                    question.difficulty_level == "EASY" ?
                                    <Styled.CodeAreaContent>
                                      <Styled.BoilerPlateTextAreaLabel>Complete Code</Styled.BoilerPlateTextAreaLabel>
                                      <Styled.BoilerPlateTextArea id={idx} onChange={(e) => this.setBoilerPlateCode(e, "predefinedCode")} value={obj.predefinedCode}></Styled.BoilerPlateTextArea>
                                    </Styled.CodeAreaContent>
                                    :
                                      (question.difficulty_level == "MEDIUM" || question.difficulty_level == "HARD") ?
                                        <>
                                        <Styled.CodeAreaContent>
                                          <Styled.BoilerPlateTextAreaLabel>fileReader Function</Styled.BoilerPlateTextAreaLabel>
                                          <Styled.BoilerPlateTextArea id={idx} onChange={(e) => this.setBoilerPlateCode(e, "fileReaderFn")} value={obj.fileReaderFn}></Styled.BoilerPlateTextArea>
                                        </Styled.CodeAreaContent>

                                        <Styled.CodeAreaContent>
                                          <Styled.BoilerPlateTextAreaLabel>CustomInput Function</Styled.BoilerPlateTextAreaLabel>
                                          <Styled.BoilerPlateTextArea id={idx} onChange={(e) => this.setBoilerPlateCode(e, "customInputFn")} value={obj.customInputFn}></Styled.BoilerPlateTextArea>
                                        </Styled.CodeAreaContent>

                                        <Styled.CodeAreaContent>
                                          <Styled.BoilerPlateTextAreaLabel>MatchOutput Function</Styled.BoilerPlateTextAreaLabel>
                                          <Styled.BoilerPlateTextArea id={idx} onChange={(e) => this.setBoilerPlateCode(e, "matchOutputFn")} value={obj.matchOutputFn}></Styled.BoilerPlateTextArea>
                                        </Styled.CodeAreaContent>

                                        <Styled.CodeAreaContent>
                                          <Styled.BoilerPlateTextAreaLabel>Solution Function</Styled.BoilerPlateTextAreaLabel>
                                          <Styled.BoilerPlateTextArea id={idx} onChange={(e) => this.setBoilerPlateCode(e, "solutionFn")} value={obj.solutionFn}></Styled.BoilerPlateTextArea>
                                        </Styled.CodeAreaContent>
                                        </>
                                      : ''
                                  }
                                </Styled.CodeAreaWrap>
                              </Styled.CompilerCodeMain>

                              <Styled.CompilerCodeSidebar>
                                {
                                  question.difficulty_level == "EASY" ?
                                  <Styled.ValidCodeButton id={obj.id} onClick={(e) => this.validateCode(idx, "boilerPlate")}>
                                    {
                                      obj.compileLoader == true ? <Buttonloader/>
                                        : 'Validate Default Code'
                                    }
                                  </Styled.ValidCodeButton>
                                  : (question.difficulty_level == "MEDIUM" || question.difficulty_level == "HARD") ?
                                    <>
                                      <Styled.ValidateButtonRow>
                                        <Styled.ValidCodeButton id={obj.id} onClick={(e) => this.validateCode(idx, "boilerPlate")}>
                                          {
                                            obj.compileLoader == true ? <Buttonloader/>
                                              : obj.compileMode == 'fileread' ? 'Validate FileReader Code' :
                                              obj.compileMode == 'custominput' ? 'Validate CustomInput Code': ''
                                          }
                                        </Styled.ValidCodeButton>
                                        <Styled.ValidCodeButton onClick={(e) => this.toggleCompileMode(e, idx, 'boilerPlate')}>
                                          {
                                            obj.compileMode == 'fileread' ? "Custom Input" : 'File Input'
                                          }
                                        </Styled.ValidCodeButton>
                                      </Styled.ValidateButtonRow>
                                      {
                                        obj?.compileMode == "custominput" ?
                                        <Styled.CustomInputBlock>
                                          <Styled.CustomInputLabel>Try Custom Input Here</Styled.CustomInputLabel>
                                          <Styled.CustomInputTextArea onChange={(e) => this.setCustomInput(e, idx, "boilerPlate")}>Custom Input</Styled.CustomInputTextArea>
                                        </Styled.CustomInputBlock>
                                      : ''
                                      }
                                    </>
                                  : ''
                                }
                                {
                                  obj?.error !== "" ?
                                  <Styled.errorMessage>{obj.error}</Styled.errorMessage>
                                  : ''
                                }
                                {
                                  obj?.outputResult?.length > 0 ?
                                    <Styled.OutputWrap>
                                      {
                                        obj?.outputResult.map ((res, ridx) => (
                                          <>
                                            <Styled.OutputDesc>Test Case{ridx + 1}: {res.description}</Styled.OutputDesc>
                                          {
                                            res.description.toLowerCase().includes('nzec') ?
                                              <Styled.OutputDesc>{res.stderr}</Styled.OutputDesc>
                                              : res.description.toLowerCase().includes('compilation error') ?
                                              <Styled.OutputDesc>{res.compiler_output}</Styled.OutputDesc>
                                              : ''
                                          }
                                          </>
                                        ))
                                      }
                                    </Styled.OutputWrap>
                                    : ''
                                }
                              </Styled.CompilerCodeSidebar>
                            </Styled.CompilerCodeRow>
                          </Styled.BoilerPlateWrap>
                        ))
                      }

                      <Styled.SubSectionDivider>
                        <Styled.BoilerPlateName style={{ marginBottom: 0 }}>
                          { question.difficulty_level === "EASY" ? "Solution Code" : "Optimized Code" }
                        </Styled.BoilerPlateName>
                        <Styled.SubSectionHint>Reference solution used for validation</Styled.SubSectionHint>
                      </Styled.SubSectionDivider>

                      <Styled.SolutionCodeRow>
                        <Styled.SolutionCodeMain>
                          <Styled.CodeAreaWrap>
                            {
                              question.difficulty_level == "EASY" ?
                                <Styled.CodeAreaContent>
                                  <Styled.BoilerPlateTextAreaLabel>Complete Code</Styled.BoilerPlateTextAreaLabel>
                                  <Styled.BoilerPlateTextArea onChange={(e) => this.setSolutionCode(e, "predefinedCode")} value={solutionCode.predefinedCode}></Styled.BoilerPlateTextArea>
                                </Styled.CodeAreaContent>
                              : (question.difficulty_level == "MEDIUM" || question.difficulty_level == "HARD") ?
                                <>
                                  <Styled.CodeAreaContent>
                                    <Styled.BoilerPlateTextAreaLabel>fileReader Function</Styled.BoilerPlateTextAreaLabel>
                                    <Styled.BoilerPlateTextArea onChange={(e) => this.setSolutionCode(e, "fileReaderFn")} value={solutionCode.fileReaderFn}></Styled.BoilerPlateTextArea>
                                  </Styled.CodeAreaContent>

                                  <Styled.CodeAreaContent>
                                    <Styled.BoilerPlateTextAreaLabel>CustomInput Function</Styled.BoilerPlateTextAreaLabel>
                                    <Styled.BoilerPlateTextArea onChange={(e) => this.setSolutionCode(e, "customInputFn")} value={solutionCode.customInputFn}></Styled.BoilerPlateTextArea>
                                  </Styled.CodeAreaContent>

                                  <Styled.CodeAreaContent>
                                    <Styled.BoilerPlateTextAreaLabel>MatchOutput Function</Styled.BoilerPlateTextAreaLabel>
                                    <Styled.BoilerPlateTextArea onChange={(e) => this.setSolutionCode(e, "matchOutputFn")} value={solutionCode.matchOutputFn}></Styled.BoilerPlateTextArea>
                                  </Styled.CodeAreaContent>

                                  <Styled.CodeAreaContent>
                                    <Styled.BoilerPlateTextAreaLabel>Solution Function</Styled.BoilerPlateTextAreaLabel>
                                    <Styled.BoilerPlateTextArea onChange={(e) => this.setSolutionCode(e, "solutionFn")} value={solutionCode.solutionFn}></Styled.BoilerPlateTextArea>
                                  </Styled.CodeAreaContent>
                                </>
                              : ''
                            }
                          </Styled.CodeAreaWrap>
                        </Styled.SolutionCodeMain>

                        <Styled.SolutionCodeSidebar>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                            {
                              question.difficulty_level == "EASY" ?
                              <Styled.ValidCodeButton onClick={(e) => this.validateCode(-1, "solutionCode")}>
                                {
                                  solutionCode.loader ? <Buttonloader/> : 'Validate Solution Code'
                                }
                              </Styled.ValidCodeButton>
                              : (question.difficulty_level == "MEDIUM" || question.difficulty_level == "HARD") ?
                              <Styled.ValidCodeButton onClick={(e) => this.validateCode(-1, "solutionCode")}>
                                {
                                  solutionCode.loader ? <Buttonloader/> :
                                  solutionCode.compileMode == 'fileread' ? 'Run Fileread Code' : 'Run CustomInput Code'
                                }
                              </Styled.ValidCodeButton>
                              : ''
                            }
                            <Dropdown title="Select Language" list={boilerPlate} value="id" name="boilerPlate" selected={this.dropdownChange} width="180px" height="48px" option="languageCode" active={question} />
                          </div>

                          {
                            (question.difficulty_level == "MEDIUM" || question.difficulty_level == "HARD") ?
                            <>
                              <Styled.ValidCodeButton onClick={(e) => this.toggleCompileMode(e, 0, 'solutionCode')} style={{ margin: '12px 0' }}>
                              {
                                solutionCode.compileMode == 'fileread' ? "Custom Input" : 'File Input'
                              }
                              </Styled.ValidCodeButton>
                              {
                                solutionCode.compileMode == 'custominput' ?
                                  <Styled.CustomInputBlock>
                                    <Styled.CustomInputLabel>Try Custom Input Here</Styled.CustomInputLabel>
                                    <Styled.CustomInputTextArea onChange={(e) => this.setCustomInput(e, 0, "solutionCode")}>Custom Input</Styled.CustomInputTextArea>
                                  </Styled.CustomInputBlock>
                                : ''
                              }
                            </>
                            : ''
                          }

                          {
                            solutionCode?.error !== "" ?
                            <Styled.errorMessage>{solutionCode.error}</Styled.errorMessage>
                            : ''
                          }

                          {
                            solutionCode?.outputResult?.length > 0 ?
                              <Styled.OutputWrap>
                                  {
                                    solutionCode?.outputResult?.map ((res, ridx) => (
                                      <>
                                          <Styled.OutputDesc>Test Case{ridx + 1}: {res.description}</Styled.OutputDesc>
                                        {
                                          res.description.toLowerCase().includes('nzec') ?
                                            <Styled.OutputDesc>{res.stderr}</Styled.OutputDesc>
                                            : res.description.toLowerCase().includes('compilation error') ?
                                            <Styled.OutputDesc>{res.compiler_output}</Styled.OutputDesc>
                                            : res.description.toLowerCase().includes('accepted') ?
                                            <>
                                              {
                                                res.hasOwnProperty("printed_output") ?
                                                  <Styled.OutputDesc style={{color:"green"}}>User Output: {res.user_output}</Styled.OutputDesc>
                                                  :
                                                  <Styled.OutputDesc style={{color:"green"}}>{res.output_matched ? "Output Matched" : "Output not matched!"}</Styled.OutputDesc>
                                              }
                                              {
                                                <Styled.OutputDesc style={{color:"green"}}>
                                                  {res.tle == true ? 'TLE' : 'Time taken'}: {res.time} Secs
                                                </Styled.OutputDesc>
                                              }
                                            </>
                                            : res.description == 'Time Limit Exceeded' ?
                                              <Styled.OutputDesc style={{color:"green"}}>
                                                Judge0 TLE: {res.time} Secs
                                              </Styled.OutputDesc>
                                            : ''
                                        }
                                        </>
                                    ))
                                  }
                              </Styled.OutputWrap>
                              : ''
                          }
                        </Styled.SolutionCodeSidebar>
                      </Styled.SolutionCodeRow>

                    </Styled.GreyBoxDiv>
                  : ''
                  }

                  { question.question_type_code === 'SQL' ?
                    <Styled.GreyBoxDiv>
                      <Styled.GreyBoxHeader>
                        <Styled.GreyBoxTitle>SQL Question</Styled.GreyBoxTitle>
                        <Styled.GreyBoxHint>Schemas, starter query, reference solution and expected results</Styled.GreyBoxHint>
                      </Styled.GreyBoxHeader>

                      <Styled.SqlRow>
                        <Styled.SqlInputWrap style={{ maxWidth: '160px' }}>
                          <Styled.InputTitleDiv>Marks</Styled.InputTitleDiv>
                          <input
                            type="number"
                            min="1"
                            value={sqlData.marks}
                            onChange={(e) => this.sqlFieldChange('marks', e.target.value)}
                          />
                        </Styled.SqlInputWrap>

                        <Styled.SqlCheckbox>
                          <input
                            type="checkbox"
                            id="sql_active"
                            checked={sqlData.active}
                            onChange={(e) => this.sqlFieldChange('active', e.target.checked)}
                          />
                          Active (available to assessments)
                        </Styled.SqlCheckbox>
                      </Styled.SqlRow>

                      <Styled.SubSectionTitle>Test Database Schemas</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>
                        Each test case runs the candidate query against one schema on the SQL test database.
                        Create a schema with its seed data here, then reference it from the test cases below.
                      </Styled.SubSectionHint>

                      <Styled.SqlSchemaPanel>
                        <Styled.SqlSchemaToolRow>
                          <Styled.SqlSchemaToolBtn
                            type="button"
                            $active={sqlSchemaForm.open}
                            onClick={() => this.toggleSqlSchemaPanel('create')}
                          >
                            Create schema
                          </Styled.SqlSchemaToolBtn>
                          <Styled.SqlSchemaToolBtn
                            type="button"
                            $active={sqlSchemaAppendForm.open}
                            onClick={() => this.toggleSqlSchemaPanel('append')}
                          >
                            Add table
                          </Styled.SqlSchemaToolBtn>
                          <Styled.SqlSchemaToolBtn
                            type="button"
                            $active={sqlSchemaRowsForm.open}
                            onClick={() => this.toggleSqlSchemaPanel('rows')}
                          >
                            Insert rows
                          </Styled.SqlSchemaToolBtn>
                        </Styled.SqlSchemaToolRow>

                        { sqlSchemaForm.open ?
                          <Styled.SqlSchemaFormPanel>
                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>Schema name</Styled.InputTitleDiv>
                              <input
                                type="text"
                                placeholder="e.g. admin_sql_test_v3"
                                value={sqlSchemaForm.schema_name}
                                onChange={(e) => this.sqlSchemaFormChange('schema_name', e.target.value)}
                              />
                            </Styled.SqlInputWrap>
                            <Styled.InputWrap>
                              <Styled.InputTitleDiv>Setup SQL (DDL + seed)</Styled.InputTitleDiv>
                              <Styled.SqlQueryTextArea
                                minHeight="100px"
                                placeholder={'CREATE TABLE employees (\n  id serial PRIMARY KEY,\n  name text,\n  salary integer\n);\n\nINSERT INTO employees (name, salary) VALUES (\'Asha\', 90000);'}
                                value={sqlSchemaForm.setup_sql}
                                onChange={(e) => this.sqlSchemaFormChange('setup_sql', e.target.value)}
                              />
                            </Styled.InputWrap>
                            <Styled.SqlRunBar>
                              <Styled.SqlButton type="button" onClick={this.createSqlSchema} disabled={sqlSchemaForm.loader}>
                                { sqlSchemaForm.loader ? <Buttonloader /> : 'Create schema' }
                              </Styled.SqlButton>
                              { sqlSchemaForm.error !== '' ? <Styled.SqlRunStatus error>{sqlSchemaForm.error}</Styled.SqlRunStatus> : null }
                              { sqlSchemaForm.success !== '' ? <Styled.SqlRunStatus>{sqlSchemaForm.success}</Styled.SqlRunStatus> : null }
                            </Styled.SqlRunBar>
                          </Styled.SqlSchemaFormPanel>
                        : null }

                        { sqlSchemaAppendForm.open ?
                          <Styled.SqlSchemaFormPanel>
                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>Schema</Styled.InputTitleDiv>
                              <select
                                value={sqlSchemaAppendForm.schema_id}
                                onChange={(e) => this.sqlSchemaAppendFormChange('schema_id', e.target.value)}
                              >
                                <option value="">Select schema</option>
                                { sqlSchemas.map((schema) => (
                                  <option key={schema.id} value={schema.id}>{schema.schema_name}</option>
                                )) }
                              </select>
                            </Styled.SqlInputWrap>
                            <Styled.InputWrap>
                              <Styled.InputTitleDiv>Table SQL</Styled.InputTitleDiv>
                              <Styled.SqlQueryTextArea
                                minHeight="90px"
                                placeholder={'CREATE TABLE departments (\n  id serial PRIMARY KEY,\n  name text\n);'}
                                value={sqlSchemaAppendForm.setup_sql}
                                onChange={(e) => this.sqlSchemaAppendFormChange('setup_sql', e.target.value)}
                              />
                            </Styled.InputWrap>
                            <Styled.SqlRunBar>
                              <Styled.SqlButton type="button" onClick={this.appendSqlSchemaTables} disabled={sqlSchemaAppendForm.loader}>
                                { sqlSchemaAppendForm.loader ? <Buttonloader /> : 'Add table' }
                              </Styled.SqlButton>
                              { sqlSchemaAppendForm.error !== '' ? <Styled.SqlRunStatus error>{sqlSchemaAppendForm.error}</Styled.SqlRunStatus> : null }
                              { sqlSchemaAppendForm.success !== '' ? <Styled.SqlRunStatus>{sqlSchemaAppendForm.success}</Styled.SqlRunStatus> : null }
                            </Styled.SqlRunBar>
                          </Styled.SqlSchemaFormPanel>
                        : null }

                        { sqlSchemaRowsForm.open ?
                          <Styled.SqlSchemaFormPanel>
                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>Schema</Styled.InputTitleDiv>
                              <select
                                value={sqlSchemaRowsForm.schema_id}
                                onChange={(e) => this.sqlSchemaRowsFormChange('schema_id', e.target.value)}
                              >
                                <option value="">Select schema</option>
                                { sqlSchemas.map((schema) => (
                                  <option key={schema.id} value={schema.id}>{schema.schema_name}</option>
                                )) }
                              </select>
                            </Styled.SqlInputWrap>
                            <Styled.InputWrap>
                              <Styled.InputTitleDiv>INSERT SQL</Styled.InputTitleDiv>
                              <Styled.SqlQueryTextArea
                                minHeight="90px"
                                placeholder={'INSERT INTO students (name, class_name, marks) VALUES\n  (\'Kavya\', \'10A\', 91);'}
                                value={sqlSchemaRowsForm.insert_sql}
                                onChange={(e) => this.sqlSchemaRowsFormChange('insert_sql', e.target.value)}
                              />
                            </Styled.InputWrap>
                            <Styled.SqlRunBar>
                              <Styled.SqlButton type="button" onClick={this.appendSqlSchemaRows} disabled={sqlSchemaRowsForm.loader}>
                                { sqlSchemaRowsForm.loader ? <Buttonloader /> : 'Insert rows' }
                              </Styled.SqlButton>
                              { sqlSchemaRowsForm.error !== '' ? <Styled.SqlRunStatus error>{sqlSchemaRowsForm.error}</Styled.SqlRunStatus> : null }
                              { sqlSchemaRowsForm.success !== '' ? <Styled.SqlRunStatus>{sqlSchemaRowsForm.success}</Styled.SqlRunStatus> : null }
                            </Styled.SqlRunBar>
                          </Styled.SqlSchemaFormPanel>
                        : null }
                      </Styled.SqlSchemaPanel>

                      <Styled.SubSectionTitle style={{ marginTop: '24px' }}>Starter Query</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>Pre-filled in the candidate's editor. Leave blank for an empty editor.</Styled.SubSectionHint>
                      <Styled.SqlQueryTextArea
                        placeholder="SELECT * FROM employees;"
                        value={sqlData.starter_query}
                        onChange={(e) => this.sqlFieldChange('starter_query', e.target.value)}
                      />

                      <Styled.SubSectionTitle style={{ marginTop: '24px' }}>Reference Solution</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>
                        Run against every schema below to generate that case's expected rows. Never sent to candidates.
                      </Styled.SubSectionHint>
                      <Styled.SqlQueryTextArea
                        minHeight="150px"
                        placeholder="SELECT name, salary FROM employees ORDER BY salary DESC;"
                        value={sqlData.solution_query}
                        onChange={(e) => this.sqlFieldChange('solution_query', e.target.value)}
                      />

                      <Styled.SubSectionTitle style={{ marginTop: '24px' }}>Hints</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>Optional. Revealed one at a time in the candidate UI.</Styled.SubSectionHint>
                      { sqlData.hints.map((hint, hintIndex) => (
                        <Styled.SqlHintRow key={hintIndex}>
                          <input
                            type="text"
                            placeholder={`Hint ${hintIndex + 1}`}
                            value={hint}
                            onChange={(e) => this.sqlHintChange(hintIndex, e.target.value)}
                          />
                          <Styled.DeleteIconButton onClick={() => this.deleteSqlHint(hintIndex)} tabIndex="-1" title="Delete hint">
                            <img src={deleteIcon} alt="delete hint" />
                          </Styled.DeleteIconButton>
                        </Styled.SqlHintRow>
                      )) }
                      <Styled.SqlButton type="button" onClick={this.addSqlHint}>+ Add hint</Styled.SqlButton>

                      <Styled.SubSectionTitle style={{ marginTop: '28px' }}>Test Cases</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>
                        You always see every case here in admin. Choose whether each case is shown to the
                        candidate during the assessment — hidden cases are still graded, but only as pass/fail.
                      </Styled.SubSectionHint>

                      { sqlData.test_cases.map((testCase, caseIndex) => (
                        <Styled.SqlCaseCard key={caseIndex} candidateHidden={testCase.is_hidden}>
                          <Styled.SqlCaseHeader>
                            <Styled.SqlCaseTitle>
                              Test case {caseIndex + 1}
                              <Styled.SqlCandidateBadge hidden={testCase.is_hidden}>
                                { testCase.test_case_code || (testCase.is_hidden ? 'HIDDEN' : 'SAMPLE') }
                              </Styled.SqlCandidateBadge>
                            </Styled.SqlCaseTitle>
                            <Styled.SqlVisibilityGroup>
                              <Styled.SqlVisibilityLabel>Candidate visibility</Styled.SqlVisibilityLabel>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Styled.SqlVisibilityToggle
                                  type="button"
                                  active={!testCase.is_hidden}
                                  onClick={() => this.sqlTestCaseChange(caseIndex, 'is_hidden', false)}
                                >
                                  Visible to candidate
                                </Styled.SqlVisibilityToggle>
                                <Styled.SqlVisibilityToggle
                                  type="button"
                                  active={testCase.is_hidden}
                                  onClick={() => this.sqlTestCaseChange(caseIndex, 'is_hidden', true)}
                                >
                                  Hidden from candidate
                                </Styled.SqlVisibilityToggle>
                                { sqlData.test_cases.length > 1 ?
                                  <Styled.DeleteIconButton onClick={() => this.deleteSqlTestCase(caseIndex)} tabIndex="-1" title="Delete test case">
                                    <img src={deleteIcon} alt="delete test case" />
                                  </Styled.DeleteIconButton>
                                : null }
                              </div>
                            </Styled.SqlVisibilityGroup>
                          </Styled.SqlCaseHeader>

                          <Styled.SqlCaseGrid>
                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>Schema</Styled.InputTitleDiv>
                              <select
                                value={testCase.schema_id}
                                onChange={(e) => {
                                  const schemaId = e.target.value;
                                  this.sqlTestCaseChange(caseIndex, 'schema_id', schemaId, () => {
                                    this.loadSqlSchemaPreview();
                                  });
                                }}
                              >
                                <option value="">Select schema</option>
                                { sqlSchemas.map((schema) => (
                                  <option key={schema.id} value={schema.id}>{schema.schema_name}</option>
                                )) }
                              </select>
                            </Styled.SqlInputWrap>

                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>Test case code (auto)</Styled.InputTitleDiv>
                              <input
                                type="text"
                                value={testCase.test_case_code}
                                readOnly
                                style={{ background: '#F9FAFB', color: '#4B5563', cursor: 'default' }}
                              />
                              <Styled.SubSectionHint style={{ margin: '6px 0 0' }}>
                                SAMPLE = visible to candidate, HIDDEN = hidden from candidate. Multiple cases can share the same code.
                              </Styled.SubSectionHint>
                            </Styled.SqlInputWrap>
                          </Styled.SqlCaseGrid>

                          <Styled.SqlCaseGrid style={{ marginTop: '14px' }}>
                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>
                                { testCase.is_hidden ? 'Case label (admin only)' : 'Tab title (shown to candidate)' }
                              </Styled.InputTitleDiv>
                              <input
                                type="text"
                                placeholder={`Case ${caseIndex + 1}`}
                                value={testCase.title}
                                onChange={(e) => this.sqlTestCaseChange(caseIndex, 'title', e.target.value)}
                              />
                            </Styled.SqlInputWrap>

                            <Styled.SqlInputWrap>
                              <Styled.InputTitleDiv>
                                { testCase.is_hidden ? 'Notes (admin only)' : 'Description (shown to candidate)' }
                              </Styled.InputTitleDiv>
                              <input
                                type="text"
                                placeholder="What this case checks"
                                value={testCase.description}
                                onChange={(e) => this.sqlTestCaseChange(caseIndex, 'description', e.target.value)}
                              />
                            </Styled.SqlInputWrap>
                          </Styled.SqlCaseGrid>

                          <Styled.InputWrap style={{ marginTop: '14px' }}>
                            <Styled.InputTitleDiv>Expected Result Override (JSON array)</Styled.InputTitleDiv>
                            <Styled.SqlQueryTextArea
                              minHeight="100px"
                              placeholder={'Leave blank to generate from the reference solution, or paste rows:\n[{"name": "Asha", "salary": 90000}]'}
                              value={testCase.expected_result}
                              onChange={(e) => this.sqlTestCaseChange(caseIndex, 'expected_result', e.target.value)}
                            />
                          </Styled.InputWrap>

                          <Styled.SqlRunBar>
                            <Styled.SqlButton type="button" onClick={() => this.runSqlTestCase(caseIndex)} disabled={testCase.runLoader}>
                              { testCase.runLoader ? <Buttonloader /> : 'Run reference solution' }
                            </Styled.SqlButton>
                            { testCase.runError !== '' ?
                              <Styled.SqlRunStatus error>{testCase.runError}</Styled.SqlRunStatus>
                            : null }
                            { testCase.runError === '' && testCase.runRows !== null ?
                              <Styled.SqlRunStatus>{testCase.runRows.length} row(s) returned</Styled.SqlRunStatus>
                            : null }
                          </Styled.SqlRunBar>

                          { testCase.runRows !== null && testCase.runRows.length > 0 ?
                            <Styled.SqlResultTable>
                              <table>
                                <thead>
                                  <tr>
                                    { Object.keys(testCase.runRows[0]).map((col) => (
                                      <th key={col}>{col}</th>
                                    )) }
                                  </tr>
                                </thead>
                                <tbody>
                                  { testCase.runRows.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                      { Object.keys(testCase.runRows[0]).map((col) => (
                                        <td key={col}>{row[col] === null || row[col] === undefined ? '' : String(row[col])}</td>
                                      )) }
                                    </tr>
                                  )) }
                                </tbody>
                              </table>
                            </Styled.SqlResultTable>
                          : null }
                        </Styled.SqlCaseCard>
                      )) }

                      <Styled.McqFooter>
                        <Styled.SqlButton type="button" onClick={this.addSqlTestCase}>
                          + Add test case
                        </Styled.SqlButton>
                        <Styled.McqFooterHint>
                          {sqlData.test_cases.length} case(s) ·{' '}
                          {sqlData.test_cases.filter((tc) => tc.is_hidden !== true).length} SAMPLE ·{' '}
                          {sqlData.test_cases.filter((tc) => tc.is_hidden === true).length} HIDDEN
                        </Styled.McqFooterHint>
                        <Styled.InputErrorDiv style={{ padding: '0px' }}>{error.sqlTestCase}</Styled.InputErrorDiv>
                      </Styled.McqFooter>

                      <Styled.SubSectionTitle style={{ marginTop: '28px' }}>Tables shown to candidate</Styled.SubSectionTitle>
                      <Styled.SubSectionHint>
                        Uncheck tables you do not want on the candidate Schema panel. Duplicate names across schemas appear as schema.table.
                      </Styled.SubSectionHint>

                      { (sqlData.available_tables || []).length > 0 ?
                        <>
                          <Styled.SqlSchemaPreviewActions>
                            <Styled.SqlButton type="button" onClick={this.selectAllSqlPreviewTables}>
                              Select all
                            </Styled.SqlButton>
                            <Styled.SqlButton type="button" onClick={this.clearSqlPreviewTables}>
                              Clear
                            </Styled.SqlButton>
                            <Styled.SubSectionHint style={{ margin: 0 }}>
                              {(sqlData.selected_table_names || []).length} of {(sqlData.available_tables || []).length} selected
                            </Styled.SubSectionHint>
                          </Styled.SqlSchemaPreviewActions>
                          <Styled.SqlSchemaPreview>
                            { sqlData.available_tables.map((table, tableIndex) => {
                              const selected = this.isSqlPreviewTableSelected(table.name);
                              return (
                                <Styled.SqlSchemaTable
                                  key={table.name || tableIndex}
                                  $selected={selected}
                                  onClick={() => this.toggleSqlPreviewTable(table)}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      e.preventDefault();
                                      this.toggleSqlPreviewTable(table);
                                    }
                                  }}
                                >
                                  <Styled.SqlSchemaTableHeader>
                                    <input
                                      type="checkbox"
                                      checked={selected}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.toggleSqlPreviewTable(table);
                                      }}
                                    />
                                    <strong>{table.name}</strong>
                                  </Styled.SqlSchemaTableHeader>
                                  { (table.columns || []).map((col, colIndex) => (
                                    <span key={colIndex}>
                                      {Array.isArray(col) ? `${col[0]} · ${col[1]}` : col}
                                    </span>
                                  )) }
                                </Styled.SqlSchemaTable>
                              );
                            }) }
                          </Styled.SqlSchemaPreview>
                        </>
                      :
                        <Styled.SubSectionHint>
                          No tables loaded yet — select a schema on a test case above to load tables from the test database.
                        </Styled.SubSectionHint>
                      }
                    </Styled.GreyBoxDiv>
                  : ''
                  }
                  {
                    question.question_type_code === 'BASH' ?
                    <>
                      <BashComponent
                        initialData={this.state.bashInitialData}
                        onChange={(bashData) => {
                          this.setState({ bashData });
                          this.removeError('bashTestCase');
                        }}
                      />
                      <Styled.InputErrorDiv style={{ padding: '0px' }}>{error.bashTestCase}</Styled.InputErrorDiv>
                    </>
                    : ''
                  }

                  <Styled.SaveWrapDiv>
                    { saveError ? 
                    <Styled.SqlRunStatus 
                      error 
                      style={{ marginRight: 'auto' }}>
                        {saveError}
                      </Styled.SqlRunStatus> : null } 
                    <Styled.CancelLink to="/assessment-question" onClick={this.cancelQuestion}>Cancel</Styled.CancelLink>
                    <Styled.SaveButton  onClick={this.saveQuestion}>Save</Styled.SaveButton>
                  </Styled.SaveWrapDiv>

                </Styled.CardDiv>
              : ''
              }
            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  assessmentQuestion: state.assessmentQuestion,
  addAssessmentQuestion: state.addAssessmentQuestion,
})

const mapDispatchToProps = {
  filterRequest,
  getRequest,
  addRequest,
  addClear,
  ownerRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAssessmentQuestion)
